<template>
  <div>
    <loading-indicator>
      <alerts-navarea-modal
        :payload="modalNavareaData"
        @close="handleNavareaModalClose"
      />
      <alerts-subscribe-modal :alerts="modalAlertsSubscribe" />
      <logbook-modal :data="modalLogbookData" />
      <orders-modal :orders="modalOrders" />
      <weather-modal
        :payload="modalWeatherData"
        @close="handleWeatherModalClose"
      />
      <folio-modal :folio="modalFolioData" />
      <agreement-modal :agreement="modalAgreementData" :device-id="selectedDeviceId" :ship="modalShipData" :user-data="modalUserData" />
      <deliveries-modal :deliveries="modalDeliveries" />
    <alerts-folio-modal
      :payload="modalFolioAlertData"
      @purchase="handleFolioAlertPurchase"
      @close="handleFolioAlertClose"
    />
      <add-ship-modal />
      <q-r-scanner-dialog />
      <home-ecdis :selected_row="selected_row" />
  
      <b-modal id="qr-code-modal" title="Telegram Bot Registration" hide-footer>
        <div v-if="qrCodeUrl" class="text-center">
          <p>Scan this QR code with your phone to get alerts in Telegram.</p>
          <img :src="qrCodeUrl" alt="QR Code" style="max-width: 100%; height: auto">
        </div>
        <div v-else class="text-center">
          <b-spinner :label="$t('general.loading', 'Loading...')" />
          <p>Loading QR code...</p>
        </div>
      </b-modal>
  
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col order="4" order-lg="1" lg="4">
                <div class="d-flex align-items-center mt-2 mb-2">
                  <b-link
                    v-if="isMobile"
                    class="mr-2 mobile-nav-icon"
                    @click="activeMobileView = activeMobileView === 'table' ? 'map' : 'table'"
                    v-b-tooltip
                    :title="activeMobileView === 'table' ? 'Show map' : 'Show table'"
                  >
                    <i :class="activeMobileView === 'table' ? 'fas fa-map-marker-alt' : 'fas fa-table'" />
                  </b-link>
  
                  <b-link
                    v-if="isMobile && activeMobileView === 'map'"
                    class="mr-2 mobile-nav-icon"
                    @click="$router.push('routes')"
                    v-b-tooltip
                    title="Routes"
                  >
                    <i class="fas fa-route" />
                  </b-link>
  
                  <b-link
                    v-if="!isMobile || activeMobileView === 'table'"
                    class="collapse-icon"
                    @click="collapseAllDetails()"
                    v-b-tooltip
                    title="Collapse all"
                  >
                    <i class="fas fa-angle-double-up" />
                  </b-link>
  
                  <b-link
                    v-if="!isMobile || activeMobileView === 'table'"
                    class="ml-2 refresh-icon"
                    @click="refreshData()"
                    v-b-tooltip
                    title="Refresh data"
                  >
                    <i class="fas fa-sync-alt" />
                  </b-link>
  
                  <b-link
                    v-if="!isMobile || activeMobileView === 'table'"
                    class="ml-2 add-ship-icon"
                    @click="addShip()"
                    v-b-tooltip
                    :title="$t('fleet.noShipsFound')"
                  >
                    <i class="fas fa-plus-circle" />
                  </b-link>
  
                  <b-link
                    v-if="!isMobile || activeMobileView === 'table'"
                    class="ml-2 search-icon"
                    @click="toggleSearchBar"
                    v-b-tooltip
                    title="Search ships"
                  >
                    <i class="fas fa-search" />
                  </b-link>
  
                  <b-link
                    v-if="!isMobile || activeMobileView === 'table'"
                    class="ml-2 qr-icon"
                    @click="showQRServiceCode"
                    v-b-tooltip
                    title="QR alert service code"
                  >
                    <i class="fas fa-qrcode" />
                  </b-link>
  
                  <b-form-input
                    v-if="showSearchBar"
                    v-model="searchQuery"
                    size="sm"
                    class="ml-2 search-input"
                    placeholder="Search ships..."
                    @input="filterTable"
                  />
                </div>
  
                <div v-if="!isMobile || activeMobileView === 'table'" class="ships-container">
                  <div v-if="tableItems && tableItems.length > 0">
                    <b-table
                      ref="fleetTable"
                      :items="tableItems"
                      :fields="shipTableFields"
                      hover
                      responsive
                      class="ship-table"
                      tbody-tr-class="ship-row"
                      @row-clicked="handleRowClick"
                      :tbody-tr-attr="rowAttributes"
                      no-border-collapse
                    >
                      <template #cell(summary)="row">
                        <div
                          :class="[
                            'summary-header',
                            {
                              'is-expanded': row.detailsShowing,
                              'is-selected': isSelectedShip(row.item.ship.deviceId)
                            }
                          ]"
                        >
                          <div class="summary-top-row">
                            <div class="summary-left ship-name">
                              {{ row.item.ship.name }}
                            </div>
                            <div class="summary-right">
                              <a
                                class="smt17 summary-agreement-link"
                                href="#"
                                @click.stop="showAgreementDetails(row.item.ship.deviceId)"
                              >
                                {{ row.item.ship.agreement ? row.item.ship.agreement : 'Stripe' }}
                              </a>
                            </div>
                          </div>
  
                          <div
                            class="summary-bottom-row"
                            v-if="fleetStore.AISData && fleetStore.AISData[row.item.ship.deviceId]"
                          >
                            <div class="summary-left destination-eta">
                              DST: {{ fleetStore.AISData[row.item.ship.deviceId].destination || 'N/A' }}, ETA:
                              {{ formatETA(fleetStore.AISData[row.item.ship.deviceId].eta) }}<span
                                v-if="shouldShowGMT(fleetStore.AISData[row.item.ship.deviceId].eta)"
                              > GMT</span>
                            </div>
                          </div>
  
                          <div class="summary-bottom-row summary-bottom-meta">
                            <div class="summary-left">
                              <div
                                v-if="!row.detailsShowing"
                                :class="['ais-status-chip', getAISTimeBasedVariant(row.item.ship.deviceId)]"
                              >
                                <span class="ais-status-dot" aria-hidden="true" />
                                <span class="ais-status-label">
                                  {{ formatAISStatusLabel(row.item.ship.deviceId) }}
                                  <span v-if="shouldShowAISTime(row.item.ship.deviceId)">
                                    - {{ formatAISTime(row.item.ship.deviceId) }}
                                  </span>
                                </span>
                              </div>
                            </div>
                            <div class="summary-right summary-bottom-actions">
                              <div
                                v-if="!row.detailsShowing"
                                class="summary-action-icons"
                              >
                                <i
                                  class="fas fa-cloud-sun action-icon light-icon"
                                  v-b-tooltip
                                  title="Weather"
                                  :class="getWeatherIconClass(row.item.ship.deviceId)"
                                  @click.stop="showWeatherData(row.item.ship.deviceId)"
                                />

                                <!--                            {{fleetStore.alerts?.folio?.[row.item.ship.deviceId]?.charts?.length}}-->

                                <i
                                  v-b-tooltip
                                  :title="$t('menu.folio', 'Folio')"
                                  :class="['fas', 'fa-map', 'action-icon', 'light-icon', getFolioIconClass(row.item.ship.deviceId)]"
                                  @click.stop="showFolioAlertDetails(row.item.ship.deviceId)"
                                />
                                <i
                                  class="fas fa-map-marker-alt action-icon light-icon"
                                  v-b-tooltip
                                  title="Navarea Warnings"
                                  :class="getNavareaIconClass(row.item.ship.deviceId)"
                                  @click.stop="showNavareaWarnings(row.item.ship.deviceId)"
                                />

                                <!-- <i
                                  class="fas fa-exclamation-triangle action-icon light-icon"
                                  v-b-tooltip
                                  title="Alerts"
                                  :class="{ 'text-danger': row.item.alerts && row.item.alerts.length > 0 }"
                                  @click.stop="showLogbookDetails(row.item.logbook)"
                                /> -->

                                <i
                                  class="fas fa-file-alt action-icon light-icon"
                                  v-b-tooltip
                                  title="Logbook"
                                  :class="{ 'text-danger': row.item.alerts && row.item.alerts.length > 0 }"
                                  @click.stop="showLogbookDetails(row.item.logbook)"
                                />
                              </div>
                              <button
                                type="button"
                                class="summary-expand-toggle"
                                :aria-label="row.detailsShowing ? 'Hide details' : 'Show details'"
                                :aria-expanded="row.detailsShowing ? 'true' : 'false'"
                                v-b-tooltip
                                :title="row.detailsShowing ? 'Hide details' : 'Show details'"
                                @click.stop="handleSummaryToggle(row, $event)"
                              >
                                <i :class="row.detailsShowing ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" aria-hidden="true" />
                                <span class="sr-only">{{ row.detailsShowing ? 'Hide details' : 'Show details' }}</span>
                              </button>
                            </div>
                          </div>

                          <transition name="summary-expand">
                            <div v-if="row.detailsShowing" class="summary-expanded">
                              <div class="summary-expanded-content">
                                <div v-if="formatAISTime(row.item.ship.deviceId)" class="summary-detail-row">
                                  <div class="summary-detail-label">
                                    AIS updated
                                  </div>
                                  <div class="summary-detail-value">
                                    <div class="summary-detail-line">
                                      {{ formatAISTime(row.item.ship.deviceId) }}
                                    </div>
                                    <template v-if="fleetStore.AISData && fleetStore.AISData[row.item.ship.deviceId]">
                                      <div class="summary-detail-line">
                                        Position: {{ formatPosition(fleetStore.AISData[row.item.ship.deviceId].payload.Position) }}
                                        <span v-if="isMobile">
                                          (
                                          <b-link @click.prevent="activeMobileView = 'map'" class="on-map-link">on map</b-link>
                                          )
                                        </span>
                                      </div>
                                      <div v-if="fleetStore.AISData[row.item.ship.deviceId].payload.CourseOverGround" class="summary-detail-line">
                                        COG: {{ fleetStore.AISData[row.item.ship.deviceId].payload.CourseOverGround }}°
                                      </div>
                                      <div v-if="fleetStore.AISData[row.item.ship.deviceId].destination" class="summary-detail-line">
                                        DST: {{ fleetStore.AISData[row.item.ship.deviceId].destination }}
                                      </div>
                                      <div v-if="fleetStore.AISData[row.item.ship.deviceId].eta" class="summary-detail-line">
                                        ETA: {{ formatETA(fleetStore.AISData[row.item.ship.deviceId].eta) }}
                                      </div>
                                    </template>
                                  </div>
                                </div>

                                <div v-if="fleetStore.hasAnyAlerts(row.item.ship.deviceId)" class="summary-detail-row">
                                  <div class="summary-detail-label">
                                    {{ $t('general.alerts', 'Alerts') }}
                                  </div>
                                  <div class="summary-detail-value summary-alert-list">
                                    <div v-if="hasAlert(row.item.ship.deviceId, 'Wind')" class="summary-alert alert-danger">
                                      <div class="summary-alert-title">
                                        Weather
                                      </div>
                                      <div class="summary-alert-text">
                                        {{ getAlertText(row.item.ship.deviceId, 'Wind') }}
                                      </div>
                                    </div>
                                    <div
                                      v-if="folioStatusAlerts(row.item.ship.deviceId)"
                                      class="summary-alert"
                                      :class="folioStatusAlerts(row.item.ship.deviceId).alertClass"
                                    >
                                      <div class="summary-alert-title">
                                        {{ folioStatusAlerts(row.item.ship.deviceId).title }}
                                      </div>
                                      <div class="summary-alert-text">
                                        {{ folioStatusAlerts(row.item.ship.deviceId).message }}
                                        <template v-if="folioStatusAlerts(row.item.ship.deviceId).details">
                                          <br>
                                          {{ folioStatusAlerts(row.item.ship.deviceId).details }}
                                        </template>
                                        <template v-if="folioStatusAlerts(row.item.ship.deviceId).cta === 'routes'">
                                          <br>
                                          <b-link
                                              href="#"
                                              @click.prevent="handleFolioAlertCta('routes')"
                                          >
                                            {{ $t('fleet.more', 'more') }}...
                                          </b-link>
                                        </template>
                                      </div>
                                    </div>
                                    <div v-if="hasAlert(row.item.ship.deviceId, 'NavArea')" class="summary-alert alert-danger">
                                      <div class="summary-alert-title">
                                        Navarea
                                      </div>
                                      <div class="summary-alert-text">
                                        {{ getAlertText(row.item.ship.deviceId, 'NavArea') }}
                                      </div>
                                    </div>
                                    <div
                                      v-if="getLatestLogbookEntry(row.item.ship.deviceId) && getLatestLogbookEntry(row.item.ship.deviceId).type === 'error'"
                                      class="summary-alert alert-danger"
                                    >
                                      <div class="summary-alert-title">
                                        Logbook
                                      </div>
                                      <div class="summary-alert-text">
                                        {{ getLatestLogbookEntry(row.item.ship.deviceId).message || 'Error reported in ship logbook' }}
                                        <div class="mt-1">
                                          <b-button
                                            size="sm"
                                            variant="outline-danger"
                                            @click="showLatestLogbookDetails(row.item.ship.deviceId)"
                                          >
                                            View Details
                                          </b-button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="summary-divider" />

                                <div class="summary-detail-row">
                                  <div class="summary-detail-label">
                                    {{ $t('fleet.account') }}
                                  </div>
                                  <div class="summary-detail-value">
                                    {{ row.item.ship.email }}
                                  </div>
                                </div>

                                <div v-if="row.item.ship.company" class="summary-detail-row">
                                  <div class="summary-detail-label">
                                    {{ $t('fleet.company') }}
                                  </div>
                                  <div class="summary-detail-value">
                                    {{ row.item.ship.company }} 
                                  </div>
                                </div>

                                <div class="summary-detail-row">
                                  <div class="summary-detail-label">
                                    Payment method
                                  </div>
                                  <div class="summary-detail-value">
                                    {{ row.item.ship.agreement ? 'Agreement: ' + row.item.ship.agreement : 'Stripe' }}
                                  </div>
                                </div>
                                <div class="summary-detail-row">
                                  <div class="summary-detail-label">
                                    {{ $t('general.dataProvider', 'Data provider') }}
                                  </div>
                                  <div class="summary-detail-value">
                                    {{ row.item.ship.provider ? row.item.ship.provider : 'Primar' }}
                                  </div>
                                </div>

                                <div class="summary-divider" />

                                <div class="summary-detail-row">
                                  <div class="summary-detail-label">
                                    Transactions
                                  </div>
                                  <div class="summary-detail-value">
                                    <template v-if="getShipOrders(row.item.ship.deviceId).length > 0">
                                      {{ getShipOrders(row.item.ship.deviceId).length }} {{ $t('fleet.orders') }}
                                      <template v-if="getShipOrders(row.item.ship.deviceId).length > 0">
                                        ({{ $t('fleet.latest') }}: #{{ getLatestOrder(row.item.ship.deviceId).displayId }}, {{ formatOrderDate(getLatestOrder(row.item.ship.deviceId).updatedAt) }}, {{ getOrderPrice(getLatestOrder(row.item.ship.deviceId)) }})
                                        <b-link href="#" @click.prevent="showOrderDetails(getShipOrders(row.item.ship.deviceId))">
                                          {{ $t('fleet.more') }}...
                                        </b-link>
                                      </template>
                                    </template>
                                    <template v-else>
                                      {{ $t('fleet.noOrders') }}
                                    </template>
                                  </div>
                                </div>

                                <div class="summary-detail-row">
                                  <div class="summary-detail-label">
                                    Folio
                                  </div>
                                  <div class="summary-detail-value">
                                    <template v-if="fleetStore.folio && fleetStore.folio.length">
                                      <template v-if="hasDeviceFolioData(row.item.ship.deviceId)">
                                        <template v-if="countItemsByType(row.item.ship.deviceId, 's63 maps') > 0">
                                          ENC: {{ countItemsByType(row.item.ship.deviceId, 's63 maps') }}
                                        </template>
                                        <b-link href="#" @click.prevent="showFolioDetails(getPaidFolioItems(row.item.ship.deviceId))">
                                          more...
                                        </b-link>
                                      </template>
                                      <template v-else>
                                        No folio data
                                      </template>
                                    </template>
                                    <template v-else>
                                      No folio data
                                    </template>
                                  </div>
                                </div>

                                <div class="summary-detail-row">
                                  <div class="summary-detail-label">
                                    Deliveries
                                  </div>
                                  <div class="summary-detail-value">
                                    <template v-if="getShipDeliveries().length > 0">
                                      {{ getShipDeliveries().length }} updates
                                      <template v-if="getShipDeliveries().length > 0">
                                        ({{ $t('fleet.latest') }}: {{ formatDeliveryDate(getLatestDelivery()) }})
                                        <b-link href="#" @click.prevent="showShipDeliveries">
                                          {{ $t('fleet.more') }}...
                                        </b-link>
                                      </template>
                                    </template>
                                    <template v-else>
                                      {{ $t('fleet.deliveries') }}
                                    </template>
                                  </div>
                                </div>

                                <div class="summary-detail-row">
                                  <div class="summary-detail-label">
                                    Logbook
                                  </div>
                                  <div class="summary-detail-value">
                                    <template v-if="getLatestLogbookEntry(row.item.ship.deviceId)">
                                      <div class="summary-detail-line">
                                        {{ formatTime(getLatestLogbookEntry(row.item.ship.deviceId).time) }}
                                      </div>
                                      <div class="summary-detail-line">
                                        {{ formatPosition(getLatestLogbookEntry(row.item.ship.deviceId).pos) }}
                                      </div>
                                      <div class="summary-detail-line">
                                        SOG: {{ getLatestLogbookEntry(row.item.ship.deviceId).sog }},
                                        COG: {{ getLatestLogbookEntry(row.item.ship.deviceId).cog }},
                                        HDG: {{ getLatestLogbookEntry(row.item.ship.deviceId).hdg }}
                                      </div>
                                      <template v-if="countLogbookMessages(row.item.ship.deviceId) > 0">
                                        <div class="summary-detail-line">
                                          {{ countLogbookMessages(row.item.ship.deviceId) }} messages
                                          <b-link href="#" @click.prevent="showLatestLogbookDetails(row.item.ship.deviceId)">
                                            more...
                                          </b-link>
                                        </div>
                                      </template>
                                    </template>
                                    <template v-else>
                                      No logbook data
                                    </template>
                                  </div>
                                </div>

                                <div class="summary-divider" />

                                <div class="summary-detail-row">
                                  <div class="summary-detail-label">
                                    Weather
                                  </div>
                                  <div class="summary-detail-value">
                                    <template v-if="fleetStore.weather && fleetStore.weather[row.item.ship.deviceId]">
                                      <div class="summary-detail-line">
                                        Wind: {{ fleetStore.weather[row.item.ship.deviceId].wind }} m/s
                                      </div>
                                      <div class="summary-detail-line">
                                        Angle: {{ fleetStore.weather[row.item.ship.deviceId].windAngle }}°
                                      </div>
                                      <div class="summary-detail-line">
                                        Temperature: {{ fleetStore.weather[row.item.ship.deviceId].temperature }}°C
                                      </div>
                                      <template v-if="fleetStore.weather[row.item.ship.deviceId].timestamp">
                                        <div class="summary-detail-line">
                                          Updated: {{ formatWeatherTime(fleetStore.weather[row.item.ship.deviceId].timestamp) }}
                                        </div>
                                      </template>
                                    </template>
                                    <template v-else>
                                      No weather data available
                                    </template>
                                  </div>
                                </div>

                                <div class="summary-detail-row">
                                  <div class="summary-detail-label">
                                    {{ $t('fleet.imo') }}
                                  </div>
                                  <div class="summary-detail-value">
                                    <span>{{ row.item.ship.imo || 'N/A' }}</span>
                                  </div>
                                </div>

                                <div class="summary-detail-row">
                                  <div class="summary-detail-label">
                                    {{ $t('fleet.deviceid') }}
                                  </div>
                                  <div class="summary-detail-value">
                                    <span>{{ row.item.ship.deviceId || 'N/A' }}</span>
                                    <template v-if="row.item.ship">
                                      <b-link href="#" @click.prevent="editShip(row.item.ship)">
                                        {{ $t('fleet.edit') }}
                                      </b-link>
                                    </template>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </transition>
                        </div>
                      </template>
  
                      <!-- Отображаем детали при клике по ячейке -->
                      <template #row-details>
                        <div class="row-details-placeholder" />
                      </template>
                    </b-table>
                  </div>
                  <div v-else class="empty-ships-message">
                    <b-alert show variant="info" class="d-flex align-items-center">
                      <i class="fas fa-info-circle mr-2" />
                      {{ $t('fleet.pressToAddShip') }}
                      <b-button variant="link" class="ml-2" @click="addShip()">
                        <i class="fas fa-plus-circle" />
                        {{ $t('fleet.addShip') }}
                      </b-button>
                    </b-alert>
                  </div>
                </div>
              </b-col>

              <b-col v-show="!isMobile || activeMobileView === 'map'" order="4" order-lg="1" lg="8">
                <b-row class="mb-1">
                  <b-col class="text-left py-0 my-0">
                    <div class="d-flex align-items-center">
                      <div
                        v-if="selected_ship"
                        ref="shipBadge"
                        class="ship-badge"
                        :class="{ 'ship-badge--clickable': hasOwnShipPosition }"
                        @click="centerMapOnShip"
                      >
                        <span>{{ getShipName }}</span>
                      </div>
                    </div>
                  </b-col>
                  <b-col />
                </b-row>
                <b-row>
                  <b-col>
                    <div ref="mapWrapper" class="map-wrapper" :style="{ height: map_size + 'px' }">
                      <home-map v-if="map" ref="homemap" :map="map" :height="map_size" :style="{ height: map_size + 'px' }" @map-destroyed="onMapDestroyed" />
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </loading-indicator>
  </div>
</template>

<script>
import HomeMap from '@/views/home/HomeMap.vue'
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import { HomeLeaf } from '@/my-leaf/home/home-leaf'
import { eventBus, home_map } from '@/main'
import { mapStores } from 'pinia'
import { useRoutesStore } from '@/stores/routes'
import { useLogbookStore } from '@/stores/logbook'
import { useFleetStore } from '@/stores/fleet'
import { useCatalogsStore } from '@/stores/catalogs'
import { prepareCatalog } from '@/my-leaf/charts/folio-leaf'
import AlertsNavareaModal from '@/views/home/modals/AlertsNavareaModal.vue'
import AlertsSubscribeModal from '@/views/home/modals/AlertsSubscribeModal.vue'
import LogbookModal from '@/views/home/modals/LogbookModal.vue'
import OrdersModal from '@/views/home/modals/OrdersModal.vue'
import FolioModal from '@/views/home/modals/FolioModal.vue'
import WeatherModal from '@/views/home/modals/WeatherModal.vue'
import DeliveriesModal from '@/views/home/modals/DeliveriesModal.vue'
import AgreementModal from '@/views/home/modals/AgreementModal.vue'
import AlertsFolioModal from '@/views/home/modals/AlertsFolioModal.vue'
import AddShipModal from '@/views/home/modals/AddShipModal.vue'
import { useDeviceStore } from '@/stores/device'
import { useUserStore } from '@/stores/user'
import { useMomentaryStore } from '@/stores/momentary'
import { myAxios } from '@/services/myAxios'
import HomeEcdis from '@/views/home/HomeEcdis.vue'
import QRScannerDialog from '@/components/qrreader/QRScannerDialog.vue'
import memoryMonitor from '@/utils/memory-monitor'
import {
  loadFleetInstallations,
  loadFleetTransactions,
  loadFleetAgreements,
  loadFleetLogbook,
  loadFleetFolio,
  loadFleetDeliveries,
  loadAllShipsAISDataAndDraw,
  loadWeather,
  loadNavarea,
  loadQrServiceCode,
  evaluateFleetFolioStatuses,
  setFolioAbortController
} from '../../helpers/apiFleet'
import { loadPorts } from '../../helpers/apiFleet'
import { hasNavareaSubscription, hasMessengersSubscription } from '@/helpers/apiServices'

export default {
  components: {
    HomeEcdis,
    HomeMap,
    LoadingIndicator,
    QRScannerDialog,
    AlertsNavareaModal,
    AlertsSubscribeModal,
    LogbookModal,
    OrdersModal,
    WeatherModal,
    FolioModal,
    AlertsFolioModal,
    AddShipModal,
    AgreementModal,
    DeliveriesModal
  },
  data() {
    return {
      folioAbortController: null, // AbortController для отмены запросов primar-charts
      openedDetailIndex: null,
      selected_ship: '',
      selected_row: null,
      ships: [],
      windowWidth: window.innerWidth,
      map: null,
      mapHeight: window.innerHeight - 200, // Высота карты для десктопа
      mapHeightMobile: window.innerHeight - 130, // Высота карты для мобильных устройств
      isFleetLoading: false,
      activeMobileView: 'table', // Активный вид для мобильных устройств (таблица или карта)

      // модальные окна
      modalOrders: [],
      modalFolioData: [],
      modalNavareaData: null,
      modalAlertsSubscribe: [],
      modalDeliveries: [],
      modalFolioAlertData: null,
      modalAgreementData: null,
      modalShipData: null,
      modalUserData: null,
      modalLogbookData: null,
      modalWeatherData: null,
      selectedDeviceId: null,

      qrCodeUrl: null, // Для хранения URL QR-кода

      shipTableFields: [{ key: 'summary', label: '' }],

      // для поиска
      showSearchBar: false, // Показывать ли строку поиска
      searchQuery: '', // Поисковый запрос
      filteredItems: null, // Отфильтрованные элементы

      shipBadgePosition: { x: 16, y: 16 },
      shipBadgeDrag: {
        active: false,
        offsetX: 0,
        offsetY: 0,
        pointerId: null,
        badgeWidth: 0,
        badgeHeight: 0,
        listenersAttached: false
      }
    }
  },
  watch: {
    // Отслеживаем изменения выбранного корабля
    selected_ship(newVal) {
      console.log('[Home] Selected ship changed:', newVal)
      // Находим данные корабля и договора
      const fleet = this.fleetStore.getFleet || []
      const selectedShip = fleet.find(ship => ship.ship.deviceId === newVal)
      const agreement = this.findAgreementByDeviceId(newVal)

      // Используем новый метод для сохранения всех данных
      console.log('[Home] Selected ship details:', selectedShip?.ship?.name, agreement?.name)
      this.deviceStore.selectDeviceWithDetails(newVal, selectedShip?.ship?.name, agreement)

      // Заполняем momentaryStore для использования на других страницах (Weather, etc.)
      if (selectedShip && selectedShip.ship) {
        const ship = selectedShip.ship
        const user = {
          email: ship?.email || 'N/A'
        }
        this.momentaryStore.setSelectedShipInfo(newVal, ship, user, agreement)
        
        // Загружаем и кэшируем подписки на сервисы для этого корабля
        this.loadAndCacheServiceSubscriptions(newVal)
      }

      this.$refs['logbook-report']?.changeShip()
      this.$refs['logbook-table']?.loadLogbook()

      // Проверяем и обновляем слой Navarea на основе подписки
      this.updateNavareaLayerForSelectedShip(newVal)

      this.$nextTick(() => {
        this.ensureShipBadgeWithinBounds()
      })
    },
    activeMobileView(newVal) {
      if (newVal === 'map') {
        this.$nextTick(() => {
          this.$refs.homemap.invalidateSize()
          this.ensureShipBadgeWithinBounds()
        })
      }
    }
  },
  async mounted() {
    this.map = new HomeLeaf();
    // Link to global stub for cross-component access
    Object.assign(home_map, this.map)

    // Создаем AbortController для отмены запросов primar-charts
    this.folioAbortController = new AbortController();
    setFolioAbortController(this.folioAbortController);
    
    // Мониторинг памяти: начальная точка
    memoryMonitor.takeSnapshot('home-mounted-start')

    // Проверка доступности API
    myAxios.get('/api/v1/manage/test')

    // Добавляем обработчик изменения размера окна
    window.addEventListener('resize', this.handleResize)

    // Отрисовываем маршрут на карте, если есть путевые точки
    // if (this.routesStore.getShipWaypointsCount > 0)
    //   this.map.drawRoute()

    // Восстанавливаем отметки из логбука на карте, если есть записи в судовом журнале
    if (this.logbookStore.logbook.length > 0) this.map.restoreReports()

    // const momentaryStore = useMomentaryStore();

    // // Проверяем, показывается ли сплэш-скрин
    // if (momentaryStore.getShowSplashFlag) {
    //   const unwatchSplash = this.$watch(
    //       () => momentaryStore.getShowSplashFlag,
    //       (newVal) => {
    //         if (!newVal) {
    //           this.isLoading = true;
    //           unwatchSplash(); // Удаляем наблюдатель после первого срабатывания
    //
    //           this.loadLayers().then(( =))
    //           this.loadFleetData();
    //         }
    //       }
    //   );
    // } else {

    memoryMonitor.takeSnapshot('home-before-load-layers')
    await this.loadLayers()
    memoryMonitor.takeSnapshot('home-after-load-layers')

    await this.$refs.homemap.initMap()
    memoryMonitor.takeSnapshot('home-after-init-map')

    this.loadFleetData()
    memoryMonitor.takeSnapshot('home-after-load-fleet')

    this.$nextTick(() => {
      this.ensureShipBadgeWithinBounds()
    })

    // Временный вывод списка IMO кораблей в консоль
    this.$nextTick(() => {
      console.log('Список IMO кораблей:', this.tableItems.map(item => item.ship.imo))
    })

    eventBus.$on('scan-info-success', () => {
      console.log('QR scan successful, refreshing fleet data...');
      // Обновляем данные после успешного сканирования QR кода
      this.refreshData();
    })

    // Обработчики событий для обновления данных после регистрации/редактирования корабля
    eventBus.$on('ship-registered', () => {
      console.log('Ship registered, refreshing fleet data...');
      // this.refreshData();
      window.location.reload();
    });

    eventBus.$on('ship-updated', () => {
      console.log('Ship updated, refreshing fleet data...');
      // this.refreshData();
      window.location.reload();
    });

    // Обработчик для закрытия модальных окон
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      switch (modalId) {
        case 'orders-modal':
          this.clearModalData('orders-modal')
          break
        case 'weather-modal':
          this.clearModalData('weather-modal')
          break
        case 'folio-modal':
          this.clearModalData('folio-modal')
          break
        case 'logbook-modal':
          this.clearModalData('logbook-modal')
          break
        case 'alerts-navarea-modal':
          this.clearModalData('alerts-navarea-modal')
          break
        case 'alerts-folio-modal':
          this.clearModalData('alerts-folio-modal')
          break
        case 'deliveries-modal':
          this.clearModalData('deliveries-modal')
          break
      }
    })

    // Обработчик для выбора корабля
    eventBus.$on('select-ship', deviceId => {
      if (!deviceId) return

      // Ищем корабль в таблице
      const fleet = this.fleetStore.getFleet || []
      const index = fleet.findIndex(item => item && item.ship && item.ship.deviceId === deviceId)

      if (index >= 0) {
        // Выбираем корабль в таблице для отображения деталей
        this.toggleDetails(index, deviceId, true)

        // Прокручиваем к выбранному кораблю
        this.$nextTick(() => {
          const shipRow = document.querySelector(`tr[data-device-id="${deviceId}"]`)
          if (shipRow) {
            shipRow.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
      }
    })

    // Обработчик для получения текущего выбранного корабля (для проверки подписок)
    eventBus.$on('get-selected-ship', () => {
      if (this.selected_ship) {
        eventBus.$emit('get-selected-ship-response', this.selected_ship)
      }
    })
  },
  beforeDestroy() {
    // Генерируем событие для очистки внешних ресурсов (графики, наблюдатели и т.д.)
    eventBus.$emit('beforeDestroy');

    // Reset global stub to prevent memory leaks and "Zombie" calls
    Object.keys(home_map).forEach(key => {
      if (key !== 'isStub') delete home_map[key];
    });
    home_map.isStub = true;

    // Отменяем все запросы primar-charts при переходе со страницы
    if (this.folioAbortController) {
      console.log('[Home] Отменяем все запросы primar-charts...');
      setFolioAbortController(null); // Сначала сообщаем, что контроллер отменен
      this.folioAbortController.abort(); // Затем отменяем запросы
    }
    
    // Устанавливаем флаг что компонент демонтируется
    this._isDestroyed = true

    // Мониторинг памяти: начало очистки
    memoryMonitor.takeSnapshot('home-destroy-start')

    this.removeShipBadgeListeners()
    this.shipBadgeDrag.active = false
    this.shipBadgeDrag.pointerId = null

    // Принудительно очищаем карту и освобождаем память (только если карта еще не была очищена)
    if (this.map) {
      try {
        this.map.destroy()
        memoryMonitor.takeSnapshot('home-after-map-destroy')
      } catch (error) {
        console.warn('Error cleaning map in index.vue:', error)
      } finally {
        // В любом случае обнуляем ссылку
        this.map = null
      }
    }

    // Отключаем все event listeners
    eventBus.$off('select-ship')
    eventBus.$off('get-selected-ship')
    eventBus.$off('scan-info-success')
    eventBus.$off('ship-registered')
    eventBus.$off('ship-updated')
    // eventBus.$off('close-aio-popup')
    // eventBus.$off('highlight-aio-on-map');
    // eventBus.$off('clear-aio-highlight');

    window.removeEventListener('resize', this.handleResize)

    // Очиститка интервалов
    if (this.logbookRefreshInterval) {
      clearInterval(this.logbookRefreshInterval)
      this.logbookRefreshInterval = null
    }

    // Очищаем все модальные данные и освобождаем память
    this.modalOrders = []
    this.modalFolioData = []
    this.modalNavareaData = null
    this.modalAlertsSubscribe = []
    this.modalDeliveries = []
    this.modalFolioAlertData = null
    this.modalLogbookData = null
    this.modalWeatherData = null
    this.modalAgreementData = null

    // Очищаем данные о кораблях и фильтрации
    this.ships = []
    this.filteredItems = null
    this.selected_ship = ''
    this.selected_row = null
    this.openedDetailIndex = null

    // Очищаем QR код URL если он был создан
    if (this.qrCodeUrl) {
      try {
        URL.revokeObjectURL(this.qrCodeUrl)
      } catch (e) {
        // Игнорируем ошибки освобождения URL
      }
      this.qrCodeUrl = null
    }

    // Принудительная очистка памяти в хранилище
    try {
      if (this.fleetStore && this.fleetStore.forceCleanupMemory) {
        this.fleetStore.forceCleanupMemory()
      }
    } catch (error) {
      console.warn('Error force clearing storage memory:', error)
    }

    this.$root.$off('bv::modal::hidden')

    // Мониторинг памяти: конец очистки
    memoryMonitor.takeSnapshot('home-destroy-end')

    // В development режиме показываем статистику памяти
    if (process.env.NODE_ENV === 'development') {
      setTimeout(() => {
        memoryMonitor.diff('home-mounted-start', 'home-destroy-end')
      }, 100)
    }
  },
  computed: {
    ...mapStores(useMomentaryStore, useRoutesStore, useLogbookStore, useUserStore, useDeviceStore, useFleetStore, useCatalogsStore),
    isMobile() {
      return this.windowWidth < 768
    },
    map_size() {
      if (this.isMobile) {
        return this.mapHeightMobile
      } else {
        const headerOffset = 120
        return window.innerHeight - headerOffset
      }
    },
    getShipName() {
      if (this.selected_ship === "") return "No selected ship";
      return this.fleetStore.getShipName(this.selected_ship);
    },

    tableItems() {
      return this.filteredItems || this.fleetStore.getFleet || []
    },

    shipBadgeStyle() {
      return {
        top: `${Math.round(this.shipBadgePosition.y)}px`,
        left: `${Math.round(this.shipBadgePosition.x)}px`
      }
    },
    hasOwnShipPosition() {
      const pos = this.fleetStore?.selectedShipPosition;
      return Boolean(pos && Number.isFinite(Number(pos.lat)) && Number.isFinite(Number(pos.lon)));
    },
  },
  methods: {
    centerMapOnShip() {
      if (!this.hasOwnShipPosition) {
        return;
      }
      const pos = this.fleetStore.selectedShipPosition;
      const lat = Number(pos.lat);
      const lon = Number(pos.lon);
      if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
        return;
      }
      try {
        const leafletMap = this.$refs.homemap?.$refs?.leafletContainer?.parentElement?.__vue__?.$el?.parentElement || this.map?.map;
        if (leafletMap && typeof leafletMap.flyTo === 'function') {
          const currentZoom = leafletMap.getZoom ? leafletMap.getZoom() : 10;
          leafletMap.flyTo([lat, lon], Math.max(currentZoom, 10), { duration: 0.6 });
        } else if (this.map?.map && typeof this.map.map.flyTo === 'function') {
          const currentZoom = this.map.map.getZoom ? this.map.map.getZoom() : 10;
          this.map.map.flyTo([lat, lon], Math.max(currentZoom, 10), { duration: 0.6 });
        }
      } catch (e) {
        console.error('centerMapOnShip error:', e);
      }
    },
    onMapDestroyed() {
      console.log('[Home] Map destroyed, clearing reference');
      this.map = null;
    },

    isRowOpen(deviceId) {
      const fleet = this.fleetStore.getFleet || []
      return (
        this.openedDetailIndex !== null &&
        this.openedDetailIndex >= 0 &&
        fleet[this.openedDetailIndex] &&
        fleet[this.openedDetailIndex].ship &&
        fleet[this.openedDetailIndex].ship.deviceId === deviceId
      )
    },

    isSelectedShip(deviceId) {
      return Boolean(deviceId) && this.selected_ship === deviceId
    },

    /**
     * Обновляет слой Navarea на основе подписки выбранного корабля
     * Проверяет, есть ли у корабля подписка на Navarea, и соответственно добавляет или удаляет слой
     * Также загружает данные Navarea если необходимо
     */
    async updateNavareaLayerForSelectedShip(deviceId) {
      try {
        // Проверяем, демонтирован ли компонент (карта может быть null при переходе на другую страницу)
        if (this._isDestroyed) {
          console.log('[home/index] Component is destroyed, skipping Navarea layer update')
          return
        }

        if (!deviceId) {
          // Нет выбранного корабля - удаляем слой Navarea
          if (this.map && this.map.removeNavareaLayer) {
            this.map.removeNavareaLayer()
          }
          return
        }

        // Проверяем подписку на Navarea
        const hasSubscription = await hasNavareaSubscription(deviceId)
        console.log(`[home/index] Navarea subscription for ${deviceId}: ${hasSubscription}`)

        // Повторная проверка - может быть демонтирован во время async вызова
        if (!this.map || this._isDestroyed) {
          console.warn('[home/index] Map object not available or component destroyed')
          return
        }

        if (hasSubscription) {
          // Добавляем слой Navarea если есть подписка
          // Данные уже загружены глобально при инициализации
          if (this.map.addNavareaLayer) {
            this.map.addNavareaLayer()
            console.log('[home/index] Navarea layer added for device', deviceId)
          }
        } else {
          // Удаляем слой Navarea если нет подписки
          if (this.map.removeNavareaLayer) {
            this.map.removeNavareaLayer()
            console.log('[home/index] Navarea layer removed (no subscription)')
          }
        }
      } catch (error) {
        console.error('[home/index] Error updating Navarea layer:', error)
        // При ошибке удаляем слой для безопасности
        if (this.map && this.map.removeNavareaLayer) {
          this.map.removeNavareaLayer()
        }
      }
    },

    // Показываем модальное окно с QR-кодом
    async showQRServiceCode() {
      try {
        // Проверяем кэшированную подписку на Messengers для выбранного корабля
        const momentaryStore = useMomentaryStore()
        const hasSubscription = momentaryStore.hasServiceSubscription('Messengers')
        console.log(`[home] Messengers subscription: ${hasSubscription}`)

        if (!hasSubscription) {
          // Нет подписки - показываем сообщение
          this.$bvToast.toast('No subscription to Messengers service', {
            title: 'No Subscription',
            variant: 'warning',
            solid: true,
            toaster: 'b-toaster-top-right'
          })
          console.warn('[home] Access denied: no Messengers subscription')
          return
        }

        // Есть подписка - показываем QR-код
        this.qrCodeUrl = null // Сбрасываем предыдущий QR-код
        this.$bvModal.show('qr-code-modal') // Показываем модальное окно
        const qrUrl = await loadQrServiceCode()
        if (qrUrl) {
          this.qrCodeUrl = qrUrl
        } else {
          // Можно добавить обработку ошибок, например, показать сообщение
          this.$bvModal.hide('qr-code-modal')
          // TODO: показать ошибку пользователю
        }
      } catch (error) {
        console.error('Error showing QR service code:', error)
        this.$bvToast.toast('Error accessing QR service code', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
    },

    handleResize() {
      this.windowWidth = window.innerWidth
      this.$forceUpdate()
      this.$nextTick(() => {
        this.ensureShipBadgeWithinBounds()
      })
    },

    // Загружаем порты, навареа, aio
    async loadLayers() {
      // this.momentaryStore.startCriticalLoading('loadLayers', 'Loading map layers...');

      try {
        const result = await Promise.all([loadNavarea(), loadPorts()])
        return result
      } finally {
        // this.momentaryStore.stopLoading('loadLayers');
      }
    },

    // Загружает все данные и рисует корабли на карте
    loadFleetData() {
      let dataAlreadyLoaded = this.fleetStore.hasInstallations
      if (dataAlreadyLoaded) {
        this.drawShipsOnMap()
        this.scheduleFolioStatusRefresh(false)
        
        // Автоматически выбираем первый корабль если данные уже загружены
        this.$nextTick(() => {
          const firstFleetItem = this.fleetStore.getFleet?.[0]
          if (firstFleetItem?.ship?.deviceId && !this.selected_ship) {
            this.applyShipSelection(firstFleetItem.ship.deviceId)
          }
        })
        return
      }

      this.momentaryStore.startCriticalLoading('loadFleetData', this.$t('general.loadingFleetData', 'Loading fleet data...'))

      Promise.all([loadFleetInstallations(), loadFleetAgreements()])
        .then(() => {
          this.momentaryStore.stopCriticalLoading('loadFleetData')

          // Запускаем загрузку AIS данных в фоне
          this.momentaryStore.startBackgroundLoading('loadAISData', 'Loading AIS data...')
          this.momentaryStore.startBackgroundLoading('loadTransactions', 'Loading transactions...')

          loadFleetTransactions(false, true).then(() => {
            this.momentaryStore.stopBackgroundLoading('loadTransactions')
          })

          loadAllShipsAISDataAndDraw().then(() => {
            this.momentaryStore.stopBackgroundLoading('loadAISData')
            // Отрисовываем корабли после завершения загрузки AIS данных
            this.drawShipsOnMap()

            // Автоматически выбираем первый корабль ПОСЛЕ отрисовки кораблей на карте
            // Используем $nextTick чтобы убедиться, что DOM обновился
            this.$nextTick(() => {
              const firstFleetItem = this.fleetStore.getFleet?.[0]
              if (firstFleetItem?.ship?.deviceId) {
                // Используем applyShipSelection для полноценного выбора корабля
                // (центрирование карты + сохранение информации)
                this.applyShipSelection(firstFleetItem.ship.deviceId)
              } else if (this.userStore.getECDISShips[0]?.value) {
                // Если нет флота, используем первый корабль из списка ECDIS
                this.applyShipSelection(this.userStore.getECDISShips[0].value)
              }
            })
          })

          this.ships = this.userStore.getECDISShips

          this.scheduleFolioStatusRefresh(true)
        })
        .catch(error => {
          console.error('Error loading fleet data:', error)
        })
        .finally(() => {
          // this.momentaryStore.stopCriticalLoading('loadFleetData');
          // this.momentaryStore.stopBackgroundLoading('loadAISData');
        })
    },

    refreshData() {
      this.momentaryStore.startCriticalLoading('refreshData', 'Refreshing data...')
      this.openedDetailIndex = null

      Promise.all([loadFleetInstallations(true), loadFleetAgreements(true)])
        .then(() => {
          this.momentaryStore.stopCriticalLoading('refreshData')

          // Запускаем загрузку транзакций в фоне
          this.momentaryStore.startBackgroundLoading('refreshTransactions', 'Loading transactions...')
          loadFleetTransactions(true, true).then(() => {
            this.momentaryStore.stopBackgroundLoading('refreshTransactions')
          })

          if (this.deviceStore.isDeviceIDExist) {
            const deviceId = this.deviceStore.getDeviceID
            // Загружаем дополнительные данные в фоне
            this.momentaryStore.startBackgroundLoading('refreshDeviceData', 'Updating device data...')
            return Promise.all([loadFleetLogbook(deviceId, true), loadFleetDeliveries(deviceId, '2024-12-06T10:16:06.695Z', true), loadFleetFolio(deviceId, true)]).finally(() => {
              this.momentaryStore.stopBackgroundLoading('refreshDeviceData')
            })
          }
        })
        .then(() => {
          this.drawShipsOnMap()
          this.scheduleFolioStatusRefresh(true)
        })
        .catch(error => {
          console.error('Error refreshing data:', error)
        })
    },

    scheduleFolioStatusRefresh(forceRefresh = false) {
      evaluateFleetFolioStatuses({ forceRefresh }).catch(error => {
        console.error('Failed to evaluate folio statuses:', error)
      })
    },

    getFolioIconClass(deviceId) {
      const summary = this.fleetStore.getFolioStatus(deviceId)
      const status = summary?.status

      if (status === 'healthy') return 'text-success'
      if (status === 'expired_all' || status === 'expiring') return 'text-danger'
      if (status === 'error') return 'text-warning'
      return 'text-secondary'
    },

    folioStatusAlerts(deviceId) {
      const summary = this.fleetStore.getFolioStatus(deviceId)
      if (!summary) return null

      const { status, stats } = summary
      if (status === 'expired_all') {
        const total = stats?.total ?? 0
        return {
          alertClass: 'alert-danger',
          title: this.$t('fleet.folioExpiredTitle', 'Charts expired'),
          message: this.$t('fleet.folioExpiredMessage', 'All purchased charts have expired.'),
          details: this.$t('fleet.folioExpiredDetails', `${total} charts require renewal.`),
          cta: 'routes',
        }
      }

      if (status === 'expiring') {
        const expiringSoon = stats?.expiringSoon ?? 0
        const expired = stats?.expired ?? 0
        const parts = []

        if (expiringSoon > 0) {
          parts.push(this.$t('fleet.folioExpiringSoon', `${expiringSoon} chart(s) expire within 30 days.`))
        }

        if (expired > 0) {
          parts.push(this.$t('fleet.folioExpiredSome', `${expired} chart(s) already expired.`))
        }

        return {
          alertClass: 'alert-danger',
          title: this.$t('fleet.folioAttentionTitle', 'Folio attention needed'),
          message: this.$t('fleet.folioAttentionMessage', 'Charts will expire soon.'),
          details: parts.join(' '),
          cta: 'routes',
        }
      }

      return null
    },

    handleFolioAlertCta(target) {
      if (target === 'routes') {
        this.$router.push({ name: 'routes', params: { openTab: 'orders' } })
      }
    },

    hasAlert(deviceId, type) {
      const { fleetStore } = this

      // Проверяем наличие данных об опасностях для корабля в alerts
      if (!fleetStore.alerts || !fleetStore.alerts[deviceId]) {
        return false
      }

      // Ищем записи типа "Wind/NavArea" для этого корабля
      const windAlerts = fleetStore.alerts[deviceId].filter(alert => alert.type === type)

      if (windAlerts.length === 0) {
        return false
      }

      const windAlert = windAlerts[0]

      // Определяем опасный ли ветер
      switch (windAlert.color) {
        case 'Red':
          return true
        case 'Yellow':
          return true
        default:
          return false
      }
    },

    getAlertText(deviceId, type) {
      const { fleetStore } = this

      // Проверяем наличие данных об опасностях для корабля в alerts
      if (!fleetStore.alerts || !fleetStore.alerts[deviceId]) {
        return 'not available'
      }

      // Ищем записи типа "Wind/NavArea" для этого корабля
      const windAlerts = fleetStore.alerts[deviceId].filter(alert => alert.type === type)

      if (windAlerts.length === 0) {
        return 'not available'
      }

      return windAlerts[0].texts.join('\n')
    },

    getWeatherIconClass(deviceId) {
      const { fleetStore } = this

      // Проверяем наличие данных об опасностях для корабля в alerts
      if (!fleetStore.alerts || !fleetStore.alerts[deviceId]) {
        return 'text-secondary' // серый цвет если нет данных
      }

      // Ищем записи типа "Wind" для этого корабля
      const windAlerts = fleetStore.alerts[deviceId].filter(alert => alert.type === 'Wind')

      if (windAlerts.length === 0) {
        return 'text-secondary' // серый цвет если нет данных о ветре
      }

      // Берем первую запись о ветре
      const windAlert = windAlerts[0]

      // Определяем цвет на основе поля color
      switch (windAlert.color) {
        case 'Red':
          return 'text-danger' // красный
        case 'Yellow':
          return 'text-warning' // желтый
        case 'Green':
          return 'text-success' // зеленый
        case 'NoColor':
        default:
          return 'text-secondary' // серый
      }
    },

    howWeatherData(deviceId) {
      const { fleetStore } = this

      // Проверяем наличие данных об опасностях для корабля
      if (!fleetStore.alerts || !fleetStore.alerts[deviceId]) {
        this.$bvToast.toast('No weather data available for this ship', {
          title: 'Weather',
          variant: 'info',
          solid: true
        })
        return
      }

      // Ищем записи типа "Wind" для этого корабля
      const windAlerts = fleetStore.alerts[deviceId].filter(alert => alert.type === 'Wind')

      if (windAlerts.length === 0) {
        this.$bvToast.toast('No wind data available for this ship', {
          title: 'Weather',
          variant: 'info',
          solid: true
        })
        return
      }

      // Находим корабль для получения имени
      const ship = fleetStore.getFleet.find(s => s.ship.deviceId === deviceId)

      // Формируем данные для модального окна на основе alerts
      this.modalWeatherData = {
        deviceId,
        shipName: ship?.ship?.name || deviceId,
        updatedAt: new Date().toISOString(),
        wind: Array.isArray(windAlerts[0]?.texts) && windAlerts[0].texts.length
          ? windAlerts[0].texts.join(' ')
          : (windAlerts[0]?.text || ''),
        alerts: windAlerts.map((alert, index) => {
          const timestamp = alert.timestamp || alert.updatedAt || alert.createdAt || null

          return {
            id: alert.id || `weather-${index}`,
            title: alert.title || `Weather alert ${index + 1}`,
            texts: Array.isArray(alert.texts) && alert.texts.length ? alert.texts : [alert.text || ''],
            message: alert.message || null,
            color: alert.color || 'Yellow',
            timestamp: timestamp ? new Date(timestamp).toISOString() : null,
          }
        }),
      }

      this.$bvModal.show('weather-modal')
    },

    loadWeatherForAllShips() {
      const { fleetStore } = this

      if (fleetStore.AISData && Object.keys(fleetStore.AISData).length > 0) {
        const promises = []

        Object.keys(fleetStore.AISData).forEach(deviceId => {
          const aisData = fleetStore.AISData[deviceId]
          if (aisData && aisData.lat && aisData.lon) {
            promises.push(loadWeather(deviceId, true))
          }
        })

        if (promises.length > 0) {
          Promise.all(promises)
            .then(() => { })
            .catch(error => {
              console.error('Error loading weather data:', error)
            })
        }
      }
    },

    formatWeatherTime(timestamp) {
      if (!timestamp) return ''
      return new Date(timestamp * 1000).toLocaleString()
    },

    // Сворачиваем все детали
    collapseAllDetails() {
      // [LOG_KEY: summary-toggle] Logging collapse action
      console.log(`[summary-toggle] Collapsing all details. Currently opened index: ${this.openedDetailIndex}`)
      
      if (this.openedDetailIndex !== null && this.openedDetailIndex >= 0) {
        const fleet = this.fleetStore.getFleet
        if (fleet && Array.isArray(fleet) && fleet.length > this.openedDetailIndex && fleet[this.openedDetailIndex]) {
          // Устанавливаем флаг _showDetails в false
          this.$set(fleet[this.openedDetailIndex], '_showDetails', false)

          if (this.$refs.fleetTable && this.$refs.fleetTable.toggleDetails) {
            this.$refs.fleetTable.toggleDetails(this.openedDetailIndex)
          }
        }

        this.openedDetailIndex = null
        this.selected_ship = ''
      }
    },

    formatETA(etaString) {
      if (!etaString) return 'N/A'
      const date = new Date(etaString)
      return date.toLocaleString()
    },

    shouldShowGMT(etaString) {
      if (!etaString) {
        return false
      }
      const formatted = this.formatETA(etaString)
      return formatted !== 'N/A' && formatted !== 'Invalid Date'
    },

    clearModalData(modalName) {
      switch (modalName) {
        case 'orders-modal':
          this.modalOrders = []
          break
        case 'weather-modal':
          this.modalWeatherData = null
          break
        case 'folio-modal':
          this.modalFolioData = []
          break
        case 'logbook-modal':
          this.modalLogbookData = null
          break
        case 'alerts-navarea-modal':
          this.modalNavareaData = null
          break
        case 'alerts-subscribe-modal':
          this.modalAlertsSubscribe = []
          break
        case 'alerts-folio-modal':
          this.modalFolioAlertData = null
          break
        case 'deliveries-modal':
          this.modalDeliveries = []
          break
      }
    },
    // Отрисовываем все корабли у которых есть позиция на карте
    drawShipsOnMap() {
      const { fleetStore } = this

      if (fleetStore.AISData && Object.keys(fleetStore.AISData).length > 0) {
        // Собираем позиции кораблей с AIS данными
        const shipPositions = []

        const fleetShips = fleetStore.getFleet || []

        // Итерируемся по всем кораблям
        fleetShips.forEach(fleetShip => {
          const deviceId = fleetShip.ship.deviceId
          const aisData = fleetStore.AISData[deviceId]

          // Проверяем, есть ли AIS данные и координаты (в разных местах структуры)
          let hasValidPosition = false
          let shipLat = null
          let shipLon = null

          if (aisData) {
            // Проверяем координаты в основной структуре (старый формат)
            if (aisData.lat && aisData.lon) {
              hasValidPosition = true
              shipLat = aisData.lat
              shipLon = aisData.lon
            }
            // Проверяем координаты в payload.Position (новый формат)
            else if (
              aisData.payload &&
              aisData.payload.Position &&
              aisData.payload.Position.lat &&
              aisData.payload.Position.lon
            ) {
              hasValidPosition = true
              shipLat = aisData.payload.Position.lat
              shipLon = aisData.payload.Position.lon
            }
          }

          if (hasValidPosition) {
            // Флаг, что данные AIS устарели
            const isOldData = this.isAISDataOld(deviceId)

            shipPositions.push({
              value: deviceId, // уникальный идентификатор корабля
              name: fleetShip.ship.name || 'Unknown ship',
              imo: fleetShip.ship.imo || 'Unknown IMO',
              position: {
                lat: shipLat,
                lon: shipLon
              },
              aisCOG: aisData.payload?.CourseOverGround || 0,
              aisStatus: this.getAISStatus(deviceId),
              speed: aisData.speedKnots || (aisData.payload?.SpeedOverGround?.Knots) || 0,
              destination: aisData.destination || aisData.payload?.Destination || 'Unknown',
              eta: aisData.eta || '',
              time: aisData.time || new Date().toISOString(),
              isOldData: isOldData
            })
          }
        })

        // Если есть позиции кораблей, рисуем их на карте
        this.map.drawShips(shipPositions, this.selected_ship)
      } else {
        console.log('No AIS data available for drawing ships on map')
      }
    },

    // Проверяем, насколько устарели данные по AIS по deviceId
    isAISDataOld(deviceId) {
      const aisData = this.fleetStore.AISData[deviceId]
      if (!aisData || !aisData.time) return false

      const aisTime = new Date(aisData.time)
      const currentTime = new Date()

      const hoursDifference = (currentTime - aisTime) / (1000 * 60 * 60)

      // Данные устарели если прошло более 10 часов
      return hoursDifference > 10
    },

    // Проверяем наличие карт в фолио корабля по deviceId
    hasDeviceFolioData(deviceId) {
      if (!this.fleetStore.folio) return false
      const deviceFolioItems = this.fleetStore.folio.filter(item => item.deviceId === deviceId && item.isPaid === true)

      return deviceFolioItems.some(folioItem => folioItem.items && folioItem.items.length > 0)
    },

    // Получаем количество данных определенного типа в фолио корабля (например, карты S63, AVCS и т.д.) по deviceId
    countItemsByType(deviceId, itemType) {
      if (!this.fleetStore.folio) return 0

      // Список всех купленных данных
      const deviceFolioItems = this.fleetStore.folio.filter(item => item.deviceId === deviceId && item.isPaid === true && item.status === 'complete')

      // Считаем количество данных определенного типа
      let count = 0
      deviceFolioItems.forEach(folioItem => {
        if (folioItem.items && folioItem.items.length) {
          count += folioItem.items.filter(item => item.type === itemType).length
        }
      })

      return count
    },

    // Получаем заказы корабля по deviceId
    getShipOrders(deviceId) {
      const orders = this.fleetStore.transactions || []
      return orders.filter(order => order.device && order.device.deviceId === deviceId)
    },

    getLatestOrder(deviceId) {
      const orders = this.getShipOrders(deviceId)
      if (orders.length === 0) return null

      // Sort by updatedAt in descending order (newest first)
      return orders.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0]
    },

    // Форматируем дату заказа
    formatOrderDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString()
    },

    // Получаем цену заказа с валютой
    getOrderPrice(order) {
      if (!order || !order.price) return ''
      return `${order.price.price} ${order.price.currency}`
    },

    // TODO
    hasPaidFolioItems(deviceId) {
      // eslint-disable-next-line no-unused-vars
      const _ = deviceId // Temporarily unused until implementation is complete
      return false
      // if (!this.fleetStore.folio) return false;
      // return this.fleetStore.folio.some(item => item.deviceId === deviceId && item.isPaid === true && item.status === 'complete');
    },

    // Получаем оплаченные данные фолио для корабля по deviceId
    getPaidFolioItems(deviceId) {
      if (!this.fleetStore.folio) return []
      return this.fleetStore.folio.filter(item => item.deviceId === deviceId && item.isPaid === true && item.status === 'complete')
    },

    // Получаем последние записи из логбука для корабля по deviceId
    getLatestLogbookEntry(deviceId) {
      if (!this.fleetStore.logbook) return null

      // Логи с экдиса
      const ecdisLogs = this.fleetStore.logbook.ecdis?.filter(msg => msg.deviceId === deviceId) || []

      // Логи из веб-интерфейса
      const webLogs = this.fleetStore.logbook.web?.filter(msg => msg.deviceId === deviceId) || []

      // Объединяем логи из ECDIS и Web и сортируем их по времени (новейшие первыми)
      const combinedLogs = [...ecdisLogs, ...webLogs].sort((a, b) => new Date(b.time) - new Date(a.time))

      // Возвращаем самый последний лог если есть
      return combinedLogs.length ? combinedLogs[0] : null
    },

    // Получаем количество сообщений в логбуке для корабля по deviceId
    countLogbookMessages(deviceId) {
      if (!this.fleetStore.logbook) return 0

      const ecdisCount = this.fleetStore.logbook.ecdis?.filter(msg => msg.deviceId === deviceId).length || 0

      const webCount = this.fleetStore.logbook.web?.filter(msg => msg.deviceId === deviceId).length || 0

      return ecdisCount + webCount
    },

    // Форматируем время для отображения
    formatTime(timeString) {
      if (!timeString) return ''
      const date = new Date(timeString)
      return date.toLocaleString()
    },

    // Форматируем позицию для отображения
    formatPosition(pos) {
      if (!pos) return ''
      if (pos && pos.lat && pos.lon) {
        // Округляем координаты до 6 знаков после запятой
        const lat = parseFloat(pos.lat).toFixed(6)
        const lon = parseFloat(pos.lon).toFixed(6)
        return `${lat}, ${lon}`
      }
      return this.$t('general.noPosition', 'no position')
    },

    // Показываем детали логбука в модальном окне
    showLatestLogbookDetails(deviceId) {
      if (!this.fleetStore.logbook) return

      // Логи с экдиса
      const ecdisLogs = this.fleetStore.logbook.ecdis?.filter(msg => msg.deviceId === deviceId) || []

      // Логи из веб-интерфейса
      const webLogs = this.fleetStore.logbook.web?.filter(msg => msg.deviceId === deviceId) || []

      // Объединяем логи из ECDIS и Web
      const combinedLogs = [...ecdisLogs, ...webLogs]

      if (combinedLogs.length === 0) return

      // Сортируем логи по времени (новейшие первыми)
      const sortedLogs = combinedLogs.sort((a, b) => new Date(b.time) - new Date(a.time))

      // Получаем самый последний лог
      const latestEntry = sortedLogs[0]

      // Формируем данные для отображения в логбуке
      const logbookData = {
        time: this.formatTime(latestEntry.time),
        position: this.formatPosition(latestEntry.pos),
        spd: latestEntry.sog,
        cog: latestEntry.cog,
        hdg: latestEntry.hdg,
        route: latestEntry.route || 'Unknown',
        messages: sortedLogs.map(msg => ({
          time: this.formatTime(msg.time),
          type: msg.source || (msg.isEcdis ? 'ecdis' : 'web'),
          position: this.formatPosition(msg.pos),
          message: msg.message
        }))
      }

      this.showLogbookDetails(logbookData)
    },

    // Получаем отгрузки
    getShipDeliveries() {
      return useFleetStore().deliveries
    },

    // Получаем последнюю отгрузку
    getLatestDelivery() {
      const deliveries = this.getShipDeliveries()
      return deliveries.length > 0 ? deliveries[0] : null
    },

    // Получаем дату отгрузки в читаемом формате
    formatDeliveryDate(delivery) {
      if (!delivery || !delivery.timestamp) return ''
      const date = new Date(delivery.timestamp)
      return date.toLocaleString()
    },

    // TODO
    getStatusVariant(status) {
      switch (status) {
        case 'in transit':
          return 'success'
        case 'anchored':
          return 'danger'
        case 'berthed':
        case 'unknown':
          return 'secondary'
        default:
          return 'info'
      }
    },

    // Этот корабль принадлежит пользователю?
    isOwnShip(shipEmail) {
      return shipEmail === this.$store.state.auth.user.email
    },

    // Получаем цвет для отображения договора
    getAgreementVariant(deviceId, agreementName) {
      if (!agreementName) return 'secondary'

      // Находим договор по deviceId
      const agreement = this.findAgreementByDeviceId(deviceId)

      if (!agreement) return 'warning'

      // Проверяем срок действия договора
      const validTill = agreement.validTill
      if (!validTill) return 'warning'

      const now = new Date()
      const expiryDate = new Date(validTill)

      return expiryDate < now ? 'danger' : 'success'
    },

    // Находим договор по deviceId
    findAgreementByDeviceId(deviceId) {
      if (!this.fleetStore.agreements || !this.fleetStore.agreements.length) return null

      // Ищем договор, в котором есть устройство с данным deviceId
      for (const agreement of this.fleetStore.agreements) {
        // Проверяем, есть ли в пользователях договора устройство с данным deviceId
        if (agreement.users && agreement.users.some(user => user.deviceId === deviceId)) {
          return agreement
        }
      }
      return null
    },

    // Показываем детали договора в модальном окне
    showAgreementDetails(deviceId) {
      // Находим договор по deviceId
      const agreement = this.findAgreementByDeviceId(deviceId)
      this.selectedDeviceId = deviceId

      // Находим информацию о корабле
      const fleetItem = (this.fleetStore.getFleet || []).find(item => item.ship?.deviceId === deviceId)
      const ship = fleetItem?.ship || {}
      
      // Находим информацию о пользователе (аккаунте) - используем email из корабля
      const user = {
        email: ship?.email || 'N/A'
      }

      // Сохраняем информацию в momentaryStore для использования на других страницах
      this.momentaryStore.setSelectedShipInfo(deviceId, ship, user, agreement)
      
      // Загружаем и кэшируем подписки на сервисы для этого корабля
      this.loadAndCacheServiceSubscriptions(deviceId)

      if (agreement) {
        this.modalAgreementData = agreement
        this.modalShipData = ship
        this.modalUserData = user
        this.$bvModal.show('agreement-modal')
      } else {
        // Если договор не найден, показываем данные по умолчанию
        this.modalAgreementData = null
        this.modalShipData = ship
        this.modalUserData = user
        this.$bvModal.show('agreement-modal')
      }
    },

    // Получаем цвет статуса AIS для отображения
    getAISStatusVariant(deviceId) {
      const aisData = this.fleetStore.AISData[deviceId]
      const status = this.getAISStatus(deviceId)

      if (
        aisData &&
        aisData.payload &&
        aisData.payload.NavigationStatus &&
        status !== 'no position' &&
        status !== 'unknown'
      ) {
        return 'success'
      }

      return 'secondary'
    },

    // Форматируем время AIS для отображения
    formatAISTime(deviceId) {
      const aisData = this.fleetStore.AISData[deviceId]
      if (!aisData || !aisData.time) return ''

      const date = new Date(aisData.time)

      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `${day}/${month} ${hours}:${minutes}`
    },

    formatAISStatusLabel(deviceId) {
      const status = this.getAISStatus(deviceId)
      if (!status) return ''

      const normalized = status.replace(/\s+/g, ' ').trim()
      if (!normalized) return ''

      return normalized
        .split(' ')
        .map(word => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ''))
        .join(' ')
    },

    shouldShowAISTime(deviceId) {
      const status = this.getAISStatus(deviceId)
      if (!status) return false

      const noPositionLabel = this.$t('general.noPosition', 'no position')
      if (status.toLowerCase() === noPositionLabel.toLowerCase()) {
        return false
      }

      return Boolean(this.formatAISTime(deviceId))
    },

    // Получаем цвет статуса AIS с учетом времени
    getAISTimeBasedVariant(deviceId) {
      // Получаем стандартный цвет статуса AIS
      const statusVariant = this.getAISStatusVariant(deviceId)

      // Если статус неизвестен, возвращаем стандартный цвет
      if (this.getAISStatus(deviceId) === 'unknown') {
        return statusVariant
      }

      // Проверяем время AIS данных
      const aisData = this.fleetStore.AISData[deviceId]
      if (!aisData || !aisData.time) return statusVariant

      const aisTime = new Date(aisData.time)
      const currentTime = new Date()

      // Вычисляем разницу в часах между текущим временем и временем AIS данных
      const hoursDifference = (currentTime - aisTime) / (1000 * 60 * 60)

      // Если данные AIS устарели более 10 часов, возвращаем желтый цвет
      if (hoursDifference > 10) {
        return 'warning'
      }

      // Если данные AIS свежие, возвращаем стандартный цвет статуса
      return statusVariant
    },

    // Получаем текстовое описание статуса AIS по deviceId
    getAISStatus(deviceId) {
      const aisData = this.fleetStore.AISData[deviceId]
      if (!aisData || !aisData.payload || !aisData.payload.NavigationStatus) {
        return this.$t('general.noPosition', 'no position')
      }

      // Получаем статус навигации из AIS данных
      const statusCode = aisData.payload.NavigationStatus
      
      // Если статус уже в текстовом формате (из кэша), возвращаем как есть
      if (typeof statusCode === 'string' && isNaN(statusCode)) {
        return statusCode.toLowerCase()
      }
      
      // Расшифровываем числовой код статуса навигации из AIS данных
      switch (statusCode) {
        case '0':
          return 'under way using engine'
        case '1':
          return 'at anchor'
        case '2':
          return 'not under command'
        case '3':
          return 'restricted maneuverability'
        case '4':
          return 'constrained by draft'
        case '5':
          return 'moored'
        case '6':
          return 'aground'
        case '7':
          return 'engaged in fishing'
        case '8':
          return 'under way sailing'
        case '9':
          return 'reserved for HSC'
        case '10':
          return 'reserved for WIG'
        case '11':
          return 'reserved'
        case '12':
          return 'reserved'
        case '13':
          return 'reserved'
        case '14':
          return 'AIS-SART active'
        case '15':
          return 'undefined'
        default:
          return 'unknown'
      }
    },

    // Показываем детали заказов в модальном окне
    showOrderDetails(orders) {
      this.$bvModal.show('orders-modal')
      this.modalOrders = orders
    },

    // Показываем детали фолио в модальном окне
    showFolioDetails(paidItems) {
      this.modalFolioData = paidItems
      this.$bvModal.show('folio-modal')
    },

    // Показываем детали отгрузок в модальном окне
    showShipDeliveries() {
      this.modalDeliveries = this.getShipDeliveries()
      this.$bvModal.show('deliveries-modal')
    },

    // Показываем детали логбука в модальном окне
    showLogbookDetails(logbookData) {
      this.modalLogbookData = logbookData
      this.$bvModal.show('logbook-modal')
    },

    // Нажата кнопка добавления корабля
    addShip() {
      this.$bvModal.show('add-ship-modal')
      eventBus.$emit('clean-ship-form')
    },

    // Нажата кнопка редактирования корабля
    editShip(ship) {
      this.$root.$emit('bv::toggle::collapse', 'ship-edit')
      eventBus.$emit('clean-ship-form')

      this.$nextTick(() => {
        console.log('SHIP', ship)

        eventBus.$emit('populate-ship-form', {
          user_email: ship.emails,
          ship_appid: ship.applicationId,
          ship_name: ship.name,
          ship_imo: ship.imo,
          ship_mmsi: ship.mmsi,
          company: ship.company,
          permit_main: ship.upn1,
          permit_backup: ship.upn2,
          permit_backup2: ship.upn3,
          ship_w: ship.width,
          ship_l: ship.length,
          ship_h: ship.height,
          ship_d: ship.draught,
          ecdis_os: ship.ecdisOs,
          ecdis_brand: ship.ecdisBrand,
          ship_country: ship.flag,
          ship_callsign: ship.call,
          ship_category: ship.category,

          is_edit: true,
          deviceId: ship.deviceId
        })
      })
    },

    // Обработчик клика по строке таблицы
    handleRowClick(item, index) {
      const deviceId = item.ship.deviceId
      if (!deviceId) return

      if (this.openedDetailIndex !== null && this.openedDetailIndex !== index) {
        const fleet = this.fleetStore.getFleet || []
        const previousDeviceId =
          this.openedDetailIndex >= 0 && fleet && fleet[this.openedDetailIndex] && fleet[this.openedDetailIndex].ship
            ? fleet[this.openedDetailIndex].ship.deviceId
            : null

        this.toggleDetails(this.openedDetailIndex, previousDeviceId, false)
      }

      this.applyShipSelection(deviceId)
    },

    handleSummaryToggle(row, event) {
      const deviceId = row.item.ship.deviceId
      if (!deviceId) return

      if (event && event.currentTarget) {
        if (typeof event.currentTarget.blur === 'function') {
          event.currentTarget.blur()
        }
        this.$root.$emit('bv::hide::tooltip', event.currentTarget)
      }

      const shouldExpand = !row.detailsShowing
      // [LOG_KEY: summary-toggle] Logging toggle action with filtered context
      console.log(`[summary-toggle] Toggle button clicked for device: ${deviceId}, row.index: ${row.index}, detailsShowing: ${row.detailsShowing}, shouldExpand: ${shouldExpand}`, {
        filteredItems: this.filteredItems ? this.filteredItems.length : 'null',
        totalFleet: this.fleetStore.getFleet ? this.fleetStore.getFleet.length : 0
      })
      this.toggleDetails(row.index, deviceId, shouldExpand)
    },

    // Возвращаем цвет заголовков ранее раскрытых ячеек
    // Устанавливаем дополнительные аттрибуты для строки таблицы
    rowAttributes(item, type) {
      // Set attributes for each row in the table
      if (type === 'row') {
        const isSelected = item.ship.deviceId === this.selected_ship

        return {
          // Добавляем класс для выделенной строки
          class: isSelected ? 'selected-row' : '',
          // Добавляем device ID для отслеживания кликов
          'data-device-id': item.ship.deviceId || ''
        }
      }
      return {}
    },

    // Обработчик клика по строке таблицы для раскрытия или скрытия деталей
    toggleDetails(index, deviceId, isOpen) {
      if (!deviceId) {
        console.warn('[summary-toggle] toggleDetails called without deviceId')
        return
      }

      const fleet = this.fleetStore.getFleet
      if (!fleet || !Array.isArray(fleet)) {
        console.warn('[summary-toggle] Fleet data is not available')
        return
      }

      // [LOG_KEY: summary-toggle] Find actual index in full fleet by deviceId
      const actualIndex = fleet.findIndex(item => item.ship && item.ship.deviceId === deviceId)
      if (actualIndex < 0) {
        console.warn(`[summary-toggle] Could not find device ${deviceId} in fleet. Index from filtered: ${index}`, {
          deviceId,
          filteredIndex: index,
          fleetSize: fleet.length,
          searchQuery: this.searchQuery
        })
        return
      }

      console.log(`[summary-toggle] Found device ${deviceId} at actualIndex: ${actualIndex} (filtered index was: ${index})`)

      const currentlyOpen = this.openedDetailIndex === actualIndex
      const shouldExpand = typeof isOpen === 'boolean' ? isOpen : !currentlyOpen
      const shouldApplySelection = shouldExpand || this.selected_ship === deviceId

      if (shouldExpand === currentlyOpen) {
        if (shouldApplySelection) {
          this.applyShipSelection(deviceId)
        }
        return
      }

      const container = this.$el.querySelector('.ships-container')
      const containerRect = container ? container.getBoundingClientRect() : null
      const rowSelector = deviceId ? `tr[data-device-id="${deviceId}"]` : null
      const currentRowEl = container && rowSelector ? container.querySelector(rowSelector) : null
      const initialRowOffset = containerRect && currentRowEl ? currentRowEl.getBoundingClientRect().top - containerRect.top : null

      const previousIndex = this.openedDetailIndex
      const previousDeviceId =
        previousIndex !== null && previousIndex >= 0 && fleet[previousIndex] && fleet[previousIndex].ship
          ? fleet[previousIndex].ship.deviceId
          : null
      const shouldStabilizeScroll =
        container &&
        initialRowOffset !== null &&
        previousDeviceId &&
        previousDeviceId !== deviceId &&
        previousIndex !== null &&
        previousIndex < actualIndex

      if (shouldExpand) {
        if (previousIndex !== null && previousIndex >= 0 && previousIndex !== actualIndex) {
          if (fleet.length > previousIndex && fleet[previousIndex]) {
            this.$set(fleet[previousIndex], '_showDetails', false)
          }

          if (this.$refs.fleetTable && this.$refs.fleetTable.toggleDetails) {
            this.$refs.fleetTable.toggleDetails(previousIndex)
          }
        }

        this.openedDetailIndex = actualIndex

        if (fleet.length > actualIndex && fleet[actualIndex]) {
          this.$set(fleet[actualIndex], '_showDetails', true)
        }

        if (this.$refs.fleetTable && this.$refs.fleetTable.toggleDetails) {
          this.$nextTick(() => {
            this.$refs.fleetTable.toggleDetails(actualIndex)

            this.$nextTick(() => {
              this.stabilizeRowScroll(deviceId, initialRowOffset, shouldStabilizeScroll)
            })
          })
        } else {
          this.$nextTick(() => {
            this.stabilizeRowScroll(deviceId, initialRowOffset, shouldStabilizeScroll)
          })
        }

        if (deviceId) {
          this.momentaryStore.startBackgroundLoading('toggleDetails', 'Loading ship details...')
          Promise.all([
            loadFleetLogbook(deviceId, true),
            loadFleetDeliveries(deviceId, '2024-12-06T10:16:06.695Z', true),
            loadFleetFolio(deviceId, true)
          ]).finally(() => {
            this.momentaryStore.stopBackgroundLoading('toggleDetails')
          })
        }
      } else {
        if (!currentlyOpen) {
          if (shouldApplySelection) {
            this.applyShipSelection(deviceId)
          }
          return
        }

        if (fleet.length > actualIndex && fleet[actualIndex]) {
          this.$set(fleet[actualIndex], '_showDetails', false)
        }

        this.openedDetailIndex = null

        if (this.$refs.fleetTable && this.$refs.fleetTable.toggleDetails) {
          this.$refs.fleetTable.toggleDetails(actualIndex)
        }
      }

      if (shouldApplySelection) {
        this.applyShipSelection(deviceId)
      }
    },

    applyShipSelection(deviceId) {
      if (!deviceId) return

      // Сохраняем в localStorage для надежной синхронизации между страницами
      localStorage.setItem('selectedDeviceID', deviceId);
      this.deviceStore.selectDevice(deviceId);

      this.selected_ship = deviceId

      if (this.fleetStore.AISData && this.fleetStore.AISData[deviceId]) {
        const aisData = this.fleetStore.AISData[deviceId]
        if (aisData && aisData.lat && aisData.lon) {
          const course = aisData.payload && aisData.payload.CourseOverGround
          this.fleetStore.selectedShipPosition = {
            lat: aisData.lat,
            lon: aisData.lon,
            cog: course
          }
        } else {
          this.fleetStore.selectedShipPosition = null
        }
      } else {
        this.fleetStore.selectedShipPosition = null
      }

      if (this.map && typeof this.map.setSelectedShip === 'function') {
        this.map.setSelectedShip(deviceId)
      }
    },

    // Keeps the newly opened row steady when a previously expanded row closes above it.
    stabilizeRowScroll(deviceId, initialOffset, maintainPosition) {
      const container = this.$el.querySelector('.ships-container')
      if (!container) return

      const rowEl = container.querySelector(`tr[data-device-id="${deviceId}"]`)
      if (!rowEl) return

      if (!this.isRowOpen(deviceId)) return

      if (maintainPosition && initialOffset !== null) {
        this.realignRowAfterCollapse(container, rowEl, initialOffset)
        this.ensureRowVisible(container, rowEl, { enforceBottom: false })
        this.scheduleRowAlignment(deviceId, {
          alignTop: true
        })
      } else {
        this.ensureRowVisible(container, rowEl)
        this.scheduleRowAlignment(deviceId, {
          alignTop: false
        })
      }
    },

    realignRowAfterCollapse(container, rowEl, initialOffset) {
      const containerRect = container.getBoundingClientRect()
      const rowRect = rowEl.getBoundingClientRect()
      const newOffset = rowRect.top - containerRect.top
      const delta = newOffset - initialOffset
      if (Math.abs(delta) > 1) {
        const nextScroll = container.scrollTop + delta
        container.scrollTop = nextScroll < 0 ? 0 : nextScroll
      }
    },

    ensureRowVisible(container, rowEl, options = {}) {
      const enforceBottom = options.enforceBottom !== undefined ? options.enforceBottom : true
      const padding = 12
      const containerRect = container.getBoundingClientRect()
      const rowRect = rowEl.getBoundingClientRect()

      if (rowRect.top < containerRect.top + padding) {
        const adjustment = containerRect.top + padding - rowRect.top
        container.scrollTop = Math.max(0, container.scrollTop - adjustment)
      } else if (enforceBottom && rowRect.bottom > containerRect.bottom - padding) {
        const adjustment = rowRect.bottom - (containerRect.bottom - padding)
        container.scrollTop += adjustment
      }
    },

    scheduleRowAlignment(deviceId, options = {}) {
      const {
        alignTop = false,
        padding = 12,
        delay = 80,
        attempts = alignTop ? 2 : 1
      } = options

      const runAlignment = attempt => {
        window.setTimeout(() => {
          if (!this.isRowOpen(deviceId)) return

          const container = this.$el.querySelector('.ships-container')
          if (!container) return

          const rowEl = container.querySelector(`tr[data-device-id="${deviceId}"]`)
          if (!rowEl) return

          if (alignTop) {
            this.alignRowToTop(container, rowEl, padding)
          } else {
            this.ensureRowVisible(container, rowEl)
          }

          if (attempt + 1 < attempts) {
            runAlignment(attempt + 1)
          }
        }, delay * (attempt + 1))
      }

      this.$nextTick(() => runAlignment(0))
    },

    alignRowToTop(container, rowEl, padding = 12) {
      const containerRect = container.getBoundingClientRect()
      const rowRect = rowEl.getBoundingClientRect()
      const adjustment = rowRect.top - (containerRect.top + padding)

      if (Math.abs(adjustment) <= 1) return

      let nextScroll = container.scrollTop + adjustment
      if (nextScroll < 0) nextScroll = 0
      container.scrollTop = nextScroll
    },

    startShipBadgeDrag(event) {
      const badge = this.$refs.shipBadge
      const container = this.$refs.mapWrapper
      if (!badge || !container) return

      if (event.button !== undefined && event.button !== 0) {
        return
      }

      event.stopPropagation()

      const badgeRect = badge.getBoundingClientRect()

      this.shipBadgeDrag.active = true
      this.shipBadgeDrag.offsetX = event.clientX - badgeRect.left
      this.shipBadgeDrag.offsetY = event.clientY - badgeRect.top
      this.shipBadgeDrag.pointerId = event.pointerId
      this.shipBadgeDrag.badgeWidth = badgeRect.width
      this.shipBadgeDrag.badgeHeight = badgeRect.height

      if (typeof badge.setPointerCapture === 'function' && event.pointerId !== undefined) {
        try {
          badge.setPointerCapture(event.pointerId)
        } catch (captureError) {
          // Ignore pointer capture errors
        }
      }

      this.addShipBadgeListeners()
    },

    onShipBadgeDrag(event) {
      if (!this.shipBadgeDrag.active || (this.shipBadgeDrag.pointerId !== null && event.pointerId !== this.shipBadgeDrag.pointerId)) {
        return
      }

      const container = this.$refs.mapWrapper
      if (!container) return

      event.preventDefault()

      const containerRect = container.getBoundingClientRect()
      const badgeWidth = this.shipBadgeDrag.badgeWidth || 0
      const badgeHeight = this.shipBadgeDrag.badgeHeight || 0

      let nextX = event.clientX - containerRect.left - this.shipBadgeDrag.offsetX
      let nextY = event.clientY - containerRect.top - this.shipBadgeDrag.offsetY

      const maxX = Math.max(0, containerRect.width - badgeWidth)
      const maxY = Math.max(0, containerRect.height - badgeHeight)

      if (nextX < 0) nextX = 0
      if (nextY < 0) nextY = 0
      if (nextX > maxX) nextX = maxX
      if (nextY > maxY) nextY = maxY

      this.shipBadgePosition.x = nextX
      this.shipBadgePosition.y = nextY
    },

    stopShipBadgeDrag(event) {
      if (!this.shipBadgeDrag.active) return
      if (event && this.shipBadgeDrag.pointerId !== null && event.pointerId !== undefined && event.pointerId !== this.shipBadgeDrag.pointerId) {
        return
      }

      const badge = this.$refs.shipBadge
      if (badge && typeof badge.releasePointerCapture === 'function' && this.shipBadgeDrag.pointerId !== null) {
        try {
          badge.releasePointerCapture(this.shipBadgeDrag.pointerId)
        } catch (releaseError) {
          // Ignore pointer release errors
        }
      }

      this.shipBadgeDrag.active = false
      this.shipBadgeDrag.pointerId = null
      this.removeShipBadgeListeners()
      this.ensureShipBadgeWithinBounds()
    },

    addShipBadgeListeners() {
      if (this.shipBadgeDrag.listenersAttached) return
      window.addEventListener('pointermove', this.onShipBadgeDrag)
      window.addEventListener('pointerup', this.stopShipBadgeDrag)
      window.addEventListener('pointercancel', this.stopShipBadgeDrag)
      this.shipBadgeDrag.listenersAttached = true
    },

    removeShipBadgeListeners() {
      if (!this.shipBadgeDrag.listenersAttached) return
      window.removeEventListener('pointermove', this.onShipBadgeDrag)
      window.removeEventListener('pointerup', this.stopShipBadgeDrag)
      window.removeEventListener('pointercancel', this.stopShipBadgeDrag)
      this.shipBadgeDrag.listenersAttached = false
    },

    ensureShipBadgeWithinBounds() {
      this.$nextTick(() => {
        const container = this.$refs.mapWrapper
        const badge = this.$refs.shipBadge
        if (!container || !badge) return

        const containerRect = container.getBoundingClientRect()
        const badgeRect = badge.getBoundingClientRect()

        const maxX = Math.max(0, containerRect.width - badgeRect.width)
        const maxY = Math.max(0, containerRect.height - badgeRect.height)

        let nextX = this.shipBadgePosition.x
        let nextY = this.shipBadgePosition.y

        if (nextX < 0) nextX = 0
        if (nextY < 0) nextY = 0
        if (nextX > maxX) nextX = maxX
        if (nextY > maxY) nextY = maxY

        if (nextX !== this.shipBadgePosition.x || nextY !== this.shipBadgePosition.y) {
          this.shipBadgePosition.x = nextX
          this.shipBadgePosition.y = nextY
        }
      })
    },

    // Переключаем видимость панели поиска
    toggleSearchBar() {
      this.showSearchBar = !this.showSearchBar
      if (!this.showSearchBar) {
        this.searchQuery = ''
        this.filteredItems = null
      } else {
        this.$nextTick(() => {
          const inputElement = document.querySelector('.search-input')
          if (inputElement) inputElement.focus()
        })
      }
    },

    // Фильтруем таблицу по поисковому запросу
    filterTable() {
      if (!this.searchQuery.trim()) {
        this.filteredItems = null
        console.log('[summary-toggle] Search cleared, showing all items')
        return
      }

      const query = this.searchQuery.toLowerCase()
      const fleet = this.fleetStore.getFleet || []

      // Фильтруем элементы флота по поисковому запросу
      this.filteredItems = fleet.filter(item => {
        const ship = item.ship
        return (
          (ship.name && ship.name.toLowerCase().includes(query)) ||
          (ship.deviceId && ship.deviceId.toLowerCase().includes(query)) ||
          (ship.imo && ship.imo.toLowerCase().includes(query)) ||
          (ship.mmsi && ship.mmsi.toLowerCase().includes(query)) ||
          (ship.agreement && ship.agreement.toLowerCase().includes(query))
        )
      })

      // [LOG_KEY: summary-toggle] Logging filter action
      console.log(`[summary-toggle] Filter applied: query="${query}", results: ${this.filteredItems.length} of ${fleet.length}`, {
        query,
        filteredCount: this.filteredItems.length,
        totalCount: fleet.length,
        filteredDeviceIds: this.filteredItems.map(item => item.ship?.deviceId)
      })

      // Если есть отфильтрованные элементы, закрываем открытые детали
      this.collapseAllDetails()
    },

    // Проверяем наличие кораблей рядом с областями Navarea
    async checkShipsInNavareaWarnings() {
      const { fleetStore } = this

      // First, check if we have AIS data
      if (!fleetStore.AISData || Object.keys(fleetStore.AISData).length === 0) {
        return
      }

      try {
        // Загружаем данные Navarea если они еще не загружены
        // Используем данные из Pinia store (которые загружаются при инициализации через apiFleet)
        if (!this.navareaData && fleetStore.navarea && fleetStore.navarea.length > 0) {
          this.navareaData = fleetStore.navarea
        }

        // Если нет данных Navarea, пропускаем проверку
        if (!this.navareaData || this.navareaData.length === 0) {
          return
        }

        // Инициализируем хранилище для хранения предупреждений Navarea для каждого корабля
        if (!fleetStore.alerts) {
          fleetStore.alerts = { navarea: {} }
        } else if (!fleetStore.alerts.navarea) {
          fleetStore.alerts.navarea = {}
        }

        // Проверяем каждый корабль который имеет AIS данные
        Object.entries(fleetStore.AISData).forEach(([deviceId, shipData]) => {
          if (!shipData || !shipData.lat || !shipData.lon) return

          const shipPosition = [shipData.lat, shipData.lon]
          let isInWarningArea = false
          let matchedWarning = null

          // Проверяем каждое предупреждение Navarea
          for (const warning of this.navareaData) {
            if (isInWarningArea) break // пропускам если уже нашли предупреждение

            // Проверяем точечные объекты в locationPoints
            if (warning.locationPoints && warning.locationPoints.length > 0) {
              for (const point of warning.locationPoints) {
                if (point.lat && point.lon) {
                  const pointPosition = [parseFloat(point.lat), parseFloat(point.lon)]
                  if (this.isPointWithinDistance(shipPosition, pointPosition, 10)) {
                    isInWarningArea = true
                    matchedWarning = warning
                    break
                  }
                }
              }
            }

            // TODO
            // Проверяем многоугольники в locationAreas
            // if (!isInWarningArea && warning.locationAreas && warning.locationAreas.length > 0) {
            //   for (const area of warning.locationAreas) {
            //     if (area.points) {
            //       // Обрабатываем точечные объекты
            //       if (!Array.isArray(area.points)) {
            //         if (area.points.lat && area.points.lon) {
            //           const pointPosition = [parseFloat(area.points.lat), parseFloat(area.points.lon)];
            //           if (this.isPointWithinDistance(shipPosition, pointPosition, 10)) {
            //             isInWarningArea = true;
            //             matchedWarning = warning;
            //             break;
            //           }
            //         }
            //       } else {
            //         // Обрабатываем многоугольную область
            //         const polygonPoints = area.points.map(point => [
            //           parseFloat(point.lat),
            //           parseFloat(point.lon)
            //         ]);
            //         if (this.isPointInOrNearPolygon(shipPosition, polygonPoints)) {
            //           isInWarningArea = true;
            //           matchedWarning = warning;
            //           break;
            //         }
            //       }
            //     }
            //   }
            // }
          }

          // Обновляем предупреждения для корабля в хранилище
          if (isInWarningArea && matchedWarning) {
            fleetStore.alerts.navarea[deviceId] = {
              position: shipPosition,
              warning: matchedWarning,
              timestamp: new Date().toISOString()
            }
          } else if (fleetStore.alerts.navarea[deviceId]) {
            delete fleetStore.alerts.navarea[deviceId]
          }
        })
      } catch (error) {
        console.error('Error checking ships in Navarea warnings:', error)
      }
    },

    // Проверяем, находится ли корабль в области Navarea
    isShipInNavareaWarning(deviceId) {
      const { fleetStore } = this
      return fleetStore.alerts && fleetStore.alerts.navarea && fleetStore.alerts.navarea[deviceId]
    },

    // Получаем CSS класс для иконки Navarea в зависимости от состояния корабля
    // NOTE: В настоящий момент всегда возвращает 'text-success' т.к. проверка предупреждений
    // не используется (checkShipsInNavareaWarnings никогда не вызывается)
    getNavareaIconClass(/* deviceId */) {
      // const { fleetStore } = this
      // const deviceAlerts = Array.isArray(fleetStore.alerts?.[deviceId])
      //   ? fleetStore.alerts[deviceId]
      //   : []
      // const scopedAlerts = Array.isArray(fleetStore.alerts?.navarea?.[deviceId])
      //   ? fleetStore.alerts.navarea[deviceId]
      //   : []
      // const navareaAlerts = [...deviceAlerts, ...scopedAlerts].filter(alert => alert && alert.type === 'NavArea')
      // if (navareaAlerts.length > 0) {
      //   return 'text-danger'
      // }
      return 'text-success'
    },

    showWeatherData(deviceId) {
      const { fleetStore } = this

      // Проверяем наличие данных об опасностях для корабля
      if (!fleetStore.alerts || !fleetStore.alerts[deviceId]) {
        this.$bvToast.toast('No weather data available for this ship', {
          title: 'Weather',
          variant: 'info',
          solid: true
        })
        return
      }

      // Ищем записи типа "Wind" для этого корабля
      const windAlerts = fleetStore.alerts[deviceId].filter(alert => alert.type === 'Wind')

      if (windAlerts.length === 0) {
        this.$bvToast.toast('No wind data available for this ship', {
          title: 'Weather',
          variant: 'info',
          solid: true
        })
        return
      }

      // Находим корабль для получения имени
      const ship = fleetStore.getFleet.find(s => s.ship.deviceId === deviceId)

      // Формируем данные для модального окна на основе alerts
      this.modalWeatherData = {
        deviceId,
        shipName: ship?.ship?.name || deviceId,
        updatedAt: new Date().toISOString(),
        wind: Array.isArray(windAlerts[0]?.texts) && windAlerts[0].texts.length
          ? windAlerts[0].texts.join(' ')
          : (windAlerts[0]?.text || ''),
        alerts: windAlerts.map((alert, index) => {
          const timestamp = alert.timestamp || alert.updatedAt || alert.createdAt || null

          return {
            id: alert.id || `weather-${index}`,
            title: alert.title || `Weather alert ${index + 1}`,
            texts: Array.isArray(alert.texts) && alert.texts.length ? alert.texts : [alert.text || ''],
            message: alert.message || null,
            color: alert.color || 'Yellow',
            timestamp: timestamp ? new Date(timestamp).toISOString() : null,
          }
        }),
      }

      this.$bvModal.show('weather-modal')
    },

    // Показать подписку на алерты
    showAlertsSubscribe(deviceId) {
      this.modalAlertsSubscribe = [
        {
          deviceId: deviceId
        }
      ]

      this.$bvModal.show('alerts-subscribe-modal')
    },

    // Показываем предупреждения Navarea для корабля в модальном окне
    showNavareaWarnings(deviceId) {
      const { fleetStore } = this

      const deviceAlerts = Array.isArray(fleetStore.alerts?.[deviceId])
        ? fleetStore.alerts[deviceId]
        : []
      const scopedAlerts = Array.isArray(fleetStore.alerts?.navarea?.[deviceId])
        ? fleetStore.alerts.navarea[deviceId]
        : []

      const navareaAlerts = []
      const seenIds = new Set()
      let fallbackIndex = 1

      const appendAlert = (alert, includeAll = false) => {
        if (!alert) {
          return
        }

        if (!includeAll && alert.type !== 'NavArea') {
          return
        }

        let id = alert.id
        if (!id) {
          id = `navarea-${fallbackIndex++}`
        }

        if (seenIds.has(id)) {
          return
        }
        seenIds.add(id)

        const rawTimestamp = alert.timestamp || alert.updatedAt || alert.createdAt || null
        const parsedTimestamp = rawTimestamp ? new Date(rawTimestamp) : null
        const isoTimestamp = parsedTimestamp && !Number.isNaN(parsedTimestamp.getTime())
          ? parsedTimestamp.toISOString()
          : null

        const messageSources = []
        if (Array.isArray(alert.texts) && alert.texts.length) {
          messageSources.push(...alert.texts)
        }
        if (alert.text) {
          messageSources.push(alert.text)
        }
        if (alert.message) {
          messageSources.push(alert.message)
        }

        const message = messageSources
          .map(item => String(item).trim())
          .filter(Boolean)
          .join('\n')

        navareaAlerts.push({
          id,
          title: alert.title,
          message: message || 'No additional details provided.',
          color: alert.color || 'Yellow',
          timestamp: isoTimestamp,
        })
      }

      deviceAlerts.forEach(alert => appendAlert(alert))
      scopedAlerts.forEach(alert => appendAlert(alert, true))

      // Находим корабль для получения имени
      const ship = fleetStore.getFleet.find(s => s.ship.deviceId === deviceId)

      // Формируем данные для модального окна alerts на основе navarea alerts
      this.modalNavareaData = {
        deviceId,
        shipName: ship?.ship?.name || deviceId,
        updatedAt: new Date().toISOString(),
        alerts: navareaAlerts,
      }

      this.$bvModal.show('alerts-navarea-modal')
    },

    handleFolioAlertPurchase() {
      const targetDevice = this.modalFolioAlertData?.deviceId
      this.modalFolioAlertData = null
      this.$bvModal.hide('alerts-folio-modal')
      const route = { name: 'ship-folio' }
      if (targetDevice) {
        route.query = { deviceId: targetDevice }
      }
      this.$router.push(route)
    },

    handleFolioAlertClose() {
      this.modalFolioAlertData = null
      this.$bvModal.hide('alerts-folio-modal')
    },

    handleNavareaModalClose() {
      this.modalNavareaData = null
    },

    handleWeatherModalClose() {
      this.modalWeatherData = null
    },

    buildFolioModalPayload(deviceId, summary) {
      const safeSummary = summary || {}
      
      // Группировка ячеек в составные продукты
      const products = this.catalogsStore.getProducts
      const productsMapByCell = prepareCatalog(products)
      
      const stats = { total: 0, expired: 0, expiringSoon: 0, healthy: 0 }
      const groupedDetailsMap = new Map()

      const rawDetails = Array.isArray(safeSummary.chartDetails) ? safeSummary.chartDetails : []
      
      rawDetails.forEach(item => {
        const productId = productsMapByCell.get(item.id) || item.id
        const existing = groupedDetailsMap.get(productId)

        if (!existing || item.daysLeft < existing.daysLeft) {
          groupedDetailsMap.set(productId, {
            id: productId,
            type: item.type,
            daysLeft: item.daysLeft,
            createdUtc: item.createdUtc,
          })
        }
      })

      const chartDetails = Array.from(groupedDetailsMap.values())
      
      chartDetails.forEach(chart => {
        stats.total++
        if (chart.daysLeft <= 0) stats.expired++
        else if (chart.daysLeft <= 30) stats.expiringSoon++
        else stats.healthy++
      })

      let status = safeSummary.status
      if (chartDetails.length > 0) {
        if (stats.healthy > 0) status = 'healthy'
        else if (stats.expired === chartDetails.length) status = 'expired_all'
        else status = 'expiring'
      }

      return {
        deviceId,
        shipName: this.fleetStore.getShipName(deviceId) || deviceId,
        status: status || 'unknown',
        stats,
        chartDetails,
        charts: chartDetails.map(item => item.id),
        updatedAt: safeSummary.updatedAt || null,
      }
    },

    // Метод для показа модального окна с информацией о картах при клике на иконку фолио
    async showFolioAlertDetails(deviceId) {
      if (!deviceId) return

      const initialSummary = this.fleetStore.getFolioStatus(deviceId)
      if (!initialSummary || initialSummary.status === 'unknown') {
        this.modalFolioAlertData = this.buildFolioModalPayload(deviceId, initialSummary)
        try {
          await loadFleetFolio(deviceId, true)
        } catch (error) {
          console.error(`Failed to load folio data for ${deviceId}:`, error)
        }

        const refreshedSummary = this.fleetStore.getFolioStatus(deviceId)
        this.modalFolioAlertData = this.buildFolioModalPayload(deviceId, refreshedSummary)
        return
      }

      this.modalFolioAlertData = this.buildFolioModalPayload(deviceId, initialSummary)
    },

    /**
     * Загрузить и кэшировать подписки на сервисы для выбранного корабля
     * Вызывается один раз при выборе корабля, затем подписки используются везде без API запросов
     */
    async loadAndCacheServiceSubscriptions(deviceId) {
      try {
        const { getDeviceServices, parseDeviceSubscriptions } = await import('@/helpers/apiServices')
        
        console.log(`[home/index] Loading subscriptions for device ${deviceId}...`)
        
        // Запрашиваем подписки с API
        const services = await getDeviceServices(deviceId)
        
        // Парсим и сохраняем в store
        const subscriptions = parseDeviceSubscriptions(services)
        this.momentaryStore.setDeviceSubscriptions(subscriptions)
        
        console.log(`[home/index] Subscriptions cached:`, subscriptions)
      } catch (error) {
        console.error(`[home/index] Error loading subscriptions for device ${deviceId}:`, error)
        // Очищаем подписки если произошла ошибка
        this.momentaryStore.setDeviceSubscriptions({})
      }
    }
  }
}
</script>

<style scoped>
@import '@/assets/styles/components/buttons.css';

*,
*:after,
*:before {
  box-sizing: border-box;
}

body {
  font-family: 'Inter', sans-serif;
  line-height: 1.5;
  min-height: 100vh;
  padding: 5rem 0;
  font-size: clamp(1rem, 2.5vw, 1.125rem);
}

section {
  width: 90%;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

section+section {
  margin-top: 2.5em;
}

h1 {
  font-weight: 700;
  line-height: 1.125;
  font-size: clamp(1.5rem, 2.5vw, 2.5rem);
}

h2 {
  margin-top: 0.25em;
  color: #999;
  font-size: clamp(1.125rem, 2.5vw, 1.25rem);
}

h2+* {
  margin-top: 1.5em;
}

summary {
  background-color: #fff;
  position: relative;
  cursor: pointer;
  padding: 1em 0.5em;
  list-style: none;
}

summary::-webkit-details-marker {
  display: none;
}

details[open] {
  box-shadow: -3px 0 0 #b5bfd9;
}

details:first-of-type {
  border-top: 1px solid #b5bfd9;
}

details>div {
  padding: 2em 2em 0;
  font-size: 0.875em;
}

dl dt {
  font-weight: 700;
}

dl dt a,
dl dt .b-link {
  font-weight: normal;
}

dl div {
  margin-right: 4em;
  margin-bottom: 0.5em;
}

/* Стили для изменения отображения dt и dd в деталях таблицы */
.ship-details-content>div {
  display: block;
  /* Изменяем с flex на block для вертикального расположения */
  margin-bottom: 6px;
}

.ship-details-content dt {
  font-weight: 500;
  min-width: 100px;
  margin-right: 0.5em;
  margin-bottom: 2px;
  word-break: break-word;
  overflow-wrap: break-word;
  display: block;
  /* Гарантируем блочное отображение */
}

.ship-details-content dd {
  color: #686868;
  margin-bottom: 2px;
  margin-left: 0;
  /* Убираем левый отступ */
  word-break: break-word;
  overflow-wrap: break-word;
  display: block;
  /* Гарантируем блочное отображение */
  margin-top: 2px;
  /* Небольшой отступ сверху для разделения от dt */
}

.folio-table .date-column {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
}

.folio-table th:last-child,
.folio-table td:last-child {
  text-align: right;
}

.folio-table th.date-column {
  text-align: right;
}

.ship-alerts {
  margin: 0 -2em 0 -2em;
}

.ship-alerts .alert {
  border-radius: 0;
  margin-bottom: 0;
}

.ship-alerts .alert:first-child {
  margin-top: -0.5rem;
}

.action-icons {
  display: flex;
  gap: 12px;
  margin-left: auto;
}

.table-danger {
  background-color: #f8d7da !important;
}

.table-striped tbody tr.table-danger:nth-of-type(odd),
.table-striped tbody tr.table-danger:nth-of-type(even) {
  background-color: #f8d7da !important;
}

details dd {
  color: #686868;
}

summary h6 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
  padding: 0;
}

summary h6 strong,
summary h6 small,
summary h6 .ship-status-badge {
  margin-left: 0;
  align-self: flex-start;
}

details.selected {
  border-left: 7px solid #4299e1;
  background-color: rgba(66, 153, 225, 0.05);
}

.selected-summary {
  background-color: #ebf8ff !important;
}

.summary-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  background-color: #ffffff;
  border: 1px solid #e5e8f0;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(22, 30, 54, 0.05);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.summary-header.is-expanded {
  border-color: #4b5fdd;
  box-shadow: 0 16px 28px rgba(75, 95, 221, 0.16);
}

.summary-header.is-selected {
  border-color: #2f3fa6;
  box-shadow: 0 18px 34px rgba(47, 63, 166, 0.2);
  background: linear-gradient(135deg, #eef1ff 0%, #e2e6ff 100%);
  transform: translateY(-2px);
}

.summary-header.is-selected .ship-name {
  color: #152262;
}

.summary-top-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  gap: 12px;
}

.summary-bottom-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
}

.summary-bottom-meta {
  margin-top: 8px;
}

.summary-left {
  text-align: left;
  flex: 1;
  /* Allow left side to take available space */
}

.summary-right {
  text-align: right;
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}


.summary-top-row .summary-right {
  flex: 0 0 auto;
  gap: 0;
  margin-left: auto;
}

.summary-top-row .summary-right .summary-agreement-link {
  margin-right: 6px;
  font-weight: 600;
  color: #2b3a84;
}

.summary-top-row .summary-right .summary-agreement-link:hover {
  color: #1d275a;
}

.summary-bottom-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  gap: 8px;
}

.summary-action-icons {
  display: flex;
  align-items: center;
  gap: 9px;
}

.summary-action-icons .action-icon {
  margin: 0;
  transition: color 0.2s ease;
}

.summary-action-icons .action-icon.text-danger {
  color: #d87b7b !important;
}

.summary-action-icons .action-icon.text-warning {
  color: #d6b55c !important;
}

.summary-action-icons .action-icon.text-success {
  color: #63b58b !important;
}

.summary-action-icons .action-icon.text-danger:hover {
  color: #c46262 !important;
}

.summary-action-icons .action-icon.text-warning:hover {
  color: #c29d3f !important;
}

.summary-action-icons .action-icon.text-success:hover {
  color: #4e9c73 !important;
}

.summary-expand-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0;
  padding: 4px 8px;
  border-radius: 999px;
  border: 1px solid rgba(75, 95, 221, 0.25);
  background: rgba(231, 235, 255, 0.88);
  color: #27358c;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  white-space: nowrap;
}

.summary-expand-toggle:hover {
  background: rgba(231, 235, 255, 1);
  box-shadow: 0 6px 14px rgba(39, 53, 140, 0.2);
  transform: translateY(-1px);
}

.summary-expand-toggle:active {
  transform: translateY(0);
  box-shadow: none;
}

.summary-expand-toggle i {
  font-size: 0.85rem;
}

.ship-name {
  font-weight: 600;
  color: #1f2940;
  letter-spacing: 0.01em;
}

.normal-weight-badge {
  font-weight: normal !important;
}

.ship-name {
  font-size: 0.9em;
  font-weight: 500;
  /* Optional: slightly bolder to enhance readability */
}

.action-icons .action-icon {
  cursor: pointer;
}

.destination-eta {
  font-size: 0.9em;
  color: #767676;
}

.fleet-header {
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;
}

.ships-container {
  max-height: calc(100vh - 100px);
  height: calc(100vh - 100px);
  overflow-y: auto;
  padding: 12px;
  background-color: #f4f6fb;
  gap: 12px;
}

.ships-container a {
  color: #3a4256;
  text-decoration: none;
  border-bottom: 1px dashed rgba(37, 45, 64, 0.65);
  padding-bottom: 1px;
  transition: color 0.2s ease;
}

.ships-container a:hover {
  color: #161b28;
}

.ships-container a.collapse-icon,
.ships-container a.refresh-icon,
.ships-container a.add-ship-icon,
.ships-container a.search-icon,
.ships-container a.qr-icon,
.ships-container a.mobile-nav-icon {
  border-bottom: none;
  padding-bottom: 0;
}

/* Custom scrollbar styling for Chrome, Edge, and Safari */
.ships-container::-webkit-scrollbar {
  width: 8px;
}

.ships-container::-webkit-scrollbar-track {
  background: #f2f5f9;
}

.ships-container::-webkit-scrollbar-thumb {
  background-color: #b5bfd9;
  border-radius: 4px;
}

.light-icon {
  color: #a0a0a0;
  /* Light gray color by default */
  transition: color 0.2s ease;
}

.light-icon:hover {
  color: #505050;
  /* Darker on hover for better interaction feedback */
}

/* Make sure the container takes the available height */
.ships-container {
  display: flex;
  flex-direction: column;
}

/* Styles for the ship table with row details */
.ship-table ::v-deep tr.b-table-details {
  background-color: #f8f9fa;
  width: 100%;
}

.ship-table ::v-deep tr.b-table-details>td {
  padding: 0;
}

.ship-details-content {
  padding: 10px;
  border-top: 1px solid #dee2e6;
  background-color: #f8f9fa;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  /* Prevent horizontal overflow */
  font-size: 0.9rem;
}

.ship-alerts {
  margin: 0 0 1em 0;
}

.ship-details-content>div {
  display: block;
  /* Изменяем с flex на block для вертикального расположения */
  margin-bottom: 6px;
}

.ship-details-content dt {
  font-weight: 500;
  min-width: 100px;
  margin-right: 0.5em;
  margin-bottom: 2px;
  word-break: break-word;
  overflow-wrap: break-word;
  display: block;
  /* Гарантируем блочное отображение */
}

.ship-details-content dd {
  color: #686868;
  margin-bottom: 2px;
  margin-left: 0;
  /* Убираем левый отступ */
  word-break: break-word;
  overflow-wrap: break-word;
  display: block;
  /* Гарантируем блочное отображение */
  margin-top: 2px;
  /* Небольшой отступ сверху для разделения от dt */
}

.search-input {
  max-width: 200px;
  transition: all 0.3s ease;
}

@media (max-width: 576px) {
  .search-input {
    max-width: 120px;
  }
}

.ship-table {
  table-layout: fixed;
  width: 100%;
  word-wrap: break-word;
  /* Add this to ensure text wraps */
  overflow-wrap: break-word;
  /* Modern browsers */
}

.ship-table .selected-row {
  background-color: transparent !important;
}

.ship-table ::v-deep tr.b-table-details>td {
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  background-color: transparent !important;
  border: 0;
  height: 0;
}

.ship-table .selected-row:hover {
  background-color: transparent !important;
}

.selected-row td:first-child,
.selected-row:hover td:first-child {
  background-color: transparent !important;
}

.clickable-badge {
  cursor: pointer;
}

.clickable-badge:hover {
  opacity: 0.8;
}

.custom-ship-badge {
  text-align: center;
  white-space: normal;
  display: inline-block;
}

.ship-table ::v-deep td {
  max-width: 100%;
  overflow-wrap: break-word;
  /* Ensure text wraps */
  word-wrap: break-word;
  /* Older browsers */
  background-color: transparent !important;
  border-top: none;
  padding: 0 0 16px;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
}

.ship-table ::v-deep td.selected-header {
  background-color: transparent !important;
}

.ship-table ::v-deep tr.selected-row td {
  background-color: transparent !important;
}

.ship-table ::v-deep tr.selected-row td:first-child {
  border-left: none;
}

.ship-table ::v-deep tbody tr:hover .summary-header {
  border-color: #d3dae9;
  box-shadow: 0 12px 20px rgba(15, 24, 46, 0.08);
  transform: translateY(-2px);
}

.ship-table ::v-deep tr.selected-row .summary-header {
  border-color: #2f3fa6;
  box-shadow: 0 18px 34px rgba(47, 63, 166, 0.2);
  background: linear-gradient(135deg, #eef1ff 0%, #e2e6ff 100%);
  transform: translateY(-2px);
}

.ship-table ::v-deep tr.selected-row .summary-header .ais-status-dot {
  transform: scale(1.15);
}

.summary-right a.smt17 {
  color: #3a4256;
  font-weight: 500;
}

.summary-right a.smt17:hover {
  color: #161b28;
}

.ais-status-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #f6f7fb, #eef1f8);
  border-radius: 999px;
  padding: 4px 12px;
  color: #1f2940;
  font-weight: 500;
  font-size: 0.82rem;
  letter-spacing: 0.01em;
  line-height: 1.1;
  min-height: 30px;
  min-width: 0;
  box-shadow: inset 0 0 0 1px rgba(102, 115, 148, 0.08);
  transition: box-shadow 0.2s ease, transform 0.2s ease, background-color 0.2s ease;
}

.ais-status-chip.compact {
  padding: 3px 10px;
  font-size: 0.78rem;
}

.ais-status-label {
  text-transform: none;
  white-space: nowrap;
}

.ais-status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #8c96aa;
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.summary-expand-enter-active,
.summary-expand-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.summary-expand-enter,
.summary-expand-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.summary-expanded {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-top: 1px solid #e5e8f0;
  padding-top: 14px;
}

.summary-expanded-content {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.summary-detail-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.summary-detail-label {
  flex: 0 0 140px;
  text-transform: uppercase;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: #6a738c;
  line-height: 1.4;
}

.summary-detail-value {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #767676;
  font-size: 0.86rem;
  font-weight: 400;
  line-height: 1.4;
}

.summary-detail-value a {
  align-self: flex-start;
  display: inline-flex;
}

.summary-detail-line {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
}

.summary-alert-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.summary-alert {
  border-radius: 12px;
  padding: 12px 14px;
  box-shadow: 0 6px 14px rgba(17, 24, 39, 0.12);
}

.summary-alert-title {
  font-weight: 600;
  margin-bottom: 6px;
}

.summary-alert-text {
  font-size: 0.86rem;
  line-height: 1.4;
}

.summary-divider {
  height: 1px;
  background: #edf1f7;
  border-radius: 999px;
}

.row-details-placeholder {
  padding: 0;
  margin: 0;
  height: 0;
}

.ais-status-chip.success {
  color: #2b4f38;
}

.ais-status-chip.success .ais-status-dot {
  background-color: #45a369;
}

.ais-status-chip.warning {
  color: #57400f;
}

.ais-status-chip.warning .ais-status-dot {
  background-color: #e09a36;
}

.ais-status-chip.secondary {
  color: #3f4b64;
}

.ais-status-chip.secondary .ais-status-dot {
  background-color: #9ba4b6;
}

/* Make table in details more compact */
.ship-details-content table {
  font-size: 0.85rem;
  /* Even smaller text for tables */
}

.ship-details-content .ship-alerts .alert {
  padding: 0.4rem 0.75rem;
  margin-bottom: 0.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

/* Make the icon slightly smaller and properly aligned */
.ship-details-content .ship-alerts .alert i {
  margin-right: 0.5rem;
  font-size: 0.9em;
}

/* Make sure alert text is all on one line */
.ship-details-content .ship-alerts .alert {
  line-height: 1.2;
}

/* Ensure the alert container takes minimum space */
.ship-details-content .ship-alerts {
  margin: 0 0 0.75em 0;
}

/* Improved styling for alerts in ship details */
.ship-details-content .ship-alerts {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin: 0 0 0.75em 0;
  width: 100%;
}

.ship-details-content .ship-alerts .alert {
  padding: 0.4rem 0.75rem;
  margin-bottom: 0.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* Ensure icon alignment is consistent */
.ship-details-content .ship-alerts .alert i {
  margin-right: 0.5rem;
  font-size: 0.9em;
  flex-shrink: 0;
}

/* Fix line height to prevent multi-line alerts */
.ship-details-content .ship-alerts .alert {
  line-height: 1.2;
  min-height: 2rem;
}

/* Add a subtle separator between alerts */
.ship-details-content .ship-alerts .alert+.alert {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

/* Fix the vertical alignment of alert close buttons */
.ship-details-content .ship-alerts .alert .close {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
  margin: 0;
  font-size: 1.25rem;
  line-height: 1;
  opacity: 0.5;
}

/* Ensure the alert has proper padding for the close button */
.ship-details-content .ship-alerts .alert {
  position: relative;
  padding-right: 2.5rem;
  /* Add extra space on the right for the close button */
}

/* Ensure text is vertically centered */
.ship-details-content .ship-alerts .alert {
  display: flex;
  align-items: center;
  min-height: 2.25rem;
}

.ship-details-content .ship-alerts .alert .close,
.ship-details-content .ship-alerts .alert ::v-deep .close {
  position: absolute !important;
  right: 0.75rem !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  padding: 0 !important;
  margin: 0 !important;
  font-size: 1.25rem !important;
  line-height: 1 !important;
  opacity: 0.5;
}

/* Improve position of the alert container */
.ship-details-content .ship-alerts .alert {
  position: relative !important;
  padding-right: 2.5rem !important;
  display: flex !important;
  align-items: center !important;
  min-height: 2.25rem !important;
}

/* Make sure the close button appears above other elements */
.ship-details-content .ship-alerts .alert .close {
  z-index: 5 !important;
}

.ship-details-content .ship-alerts .alert .close,
.ship-details-content .ship-alerts .alert .btn-close,
.ship-details-content .ship-alerts .alert ::v-deep .close,
.ship-details-content .ship-alerts .alert ::v-deep .btn-close {
  position: absolute !important;
  right: 0.75rem !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  margin: 0 !important;
  padding: 0 !important;
  font-size: 1.25rem !important;
  line-height: 1 !important;
  z-index: 10 !important;
  width: 1.5rem !important;
  height: 1.5rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Ensure the alert container has proper spacing */
.ship-details-content .ship-alerts .alert {
  position: relative !important;
  padding: 0.4rem 0.75rem !important;
  padding-right: 2.5rem !important;
  margin-bottom: 0.25rem !important;
  display: flex !important;
  align-items: center !important;
  min-height: 2.25rem !important;
  box-sizing: border-box !important;
}

/* Mobile optimizations */
@media (max-width: 767px) {
  .ships-container {
    height: calc(100vh - 60px);
    max-height: calc(100vh - 60px);
  }

  .ship-details-content {
    padding: 1rem;
  }

  .mobile-nav-icon {
    display: inline-block;
  }
}

@media (min-width: 768px) {
  .mobile-nav-icon {
    display: none;
  }
}

@media (max-width: 767px) {

  .mobile-nav-icon,
  .collapse-icon,
  .refresh-icon,
  .add-ship-icon,
  .search-icon,
  .qr-icon {
    font-size: 1.5rem;
    padding: 0.5rem;
    margin-right: 0.7rem !important;
    margin-left: 0.7rem !important;
  }

  .mobile-nav-icon:first-child {
    margin-left: 0 !important;
  }

  .mobile-nav-icon i,
  .collapse-icon i,
  .refresh-icon i,
  .add-ship-icon i,
  .search-icon i {
    font-size: 1.5rem;
  }

  /* Ensure minimum touch target size */
  .d-flex.align-items-center {
    min-height: 3rem;
  }

  /* Make horizontal rules more compact */
  .ship-details-content hr {
    margin-top: 8px;
    margin-bottom: 8px;
  }

  /* Reduce padding in the table detail rows */
  .ship-table ::v-deep tr.b-table-details>td {
    padding: 0;
  }

  /* Make sure alert containers are compact */
  .ship-details-content .ship-alerts {
    margin-bottom: 6px;
  }

  .ship-details-content .ship-alerts .alert {
    padding: 6px 10px;
    margin-bottom: 6px;
  }

  .clickable-alert {
    cursor: pointer;
    transition: opacity 0.2s;
  }

  .clickable-alert:hover {
    opacity: 0.9;
  }

  .ship-alerts {
    margin: 0 0 12px 0;
  }

  .clickable-alert {
    cursor: pointer !important;
    position: relative !important;
    z-index: 10 !important;
    pointer-events: auto !important;
  }

  .clickable-alert:hover {
    opacity: 0.9 !important;
  }

  /* Remove any potential interfering elements */
  .clickable-alert .close,
  .clickable-alert .btn-close {
    display: none !important;
  }

  /* Make sure the entire alert is clickable */
  .clickable-alert>div {
    pointer-events: none;
  }

  /* Increase the height of the alert boxes */
  .custom-alert {
    padding: 0.75rem 0.75rem;
    /* Increased vertical padding */
    margin-bottom: 0.5rem;
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 20;
    min-height: 3rem;
    /* Set a minimum height for alerts */
  }

  /* Adjust container margins to reduce space before first and after last alert */
  .ship-alerts {
    margin: 0.5rem 0 0.5rem 0;
    /* Reduced top and bottom margins */
  }

  /* Make sure first alert has no extra top margin */
  .ship-alerts>div:first-child {
    margin-top: 0;
  }

  /* Make sure last alert has no extra bottom margin */
  .ship-alerts>div:last-child {
    margin-bottom: 0;
  }

  .alert-details-list {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .alert-details-list .custom-alert {
    display: flex;
    flex-direction: row;
    border-radius: 4px;
    padding: 12px 15px;
    background-color: #f8d7da;
    border-left: 4px solid #dc3545;
  }

  .alert-details-list dt {
    font-weight: normal !important;
    color: #000000 !important;
    min-width: 150px;
    flex-shrink: 0;
    margin-bottom: 0;
  }

  .alert-details-list dd {
    flex: 1;
    margin-bottom: 0;
    color: #721c24;
  }

  .alert-details-list .custom-alert+.custom-alert {
    margin-top: 10px;
  }

  .alert-details-list {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .alert-details-list .custom-alert {
    display: flex;
    flex-direction: row;
    border-radius: 4px;
    padding: 12px 15px;
    background-color: #f8d7da;
    border-left: 4px solid #dc3545;
    width: 100%;
    /* Ensure full width */
  }

  /* Fix the width constraints on dt/dd elements */
  .alert-details-list dt {
    font-weight: normal !important;
    color: #000000 !important;
    width: 150px;
    /* Fixed width for title */
    min-width: 150px;
    flex-shrink: 0;
    margin-bottom: 0;
    margin-right: 15px;
    /* Add some space between dt and dd */
  }

  .alert-details-list dd {
    flex: 1;
    margin-bottom: 0;
    margin-right: 0;
    /* Remove right margin */
    color: #721c24;
    width: calc(100% - 165px);
    /* Calculate remaining width */
  }

  /* Remove any right margin that might be inherited from other dl styles */
  dl div {
    margin-right: 0;
    margin-bottom: 0.5em;
    width: 100%;
  }

  /* Make sure parent containers don't restrict width */
  .ship-details-content {
    padding: 10px;
    width: 100%;
    max-width: 100%;
  }

  /* Ensure alerts take full width */
  .ship-details-content dl div,
  .ship-details-content .alert-details-list {
    width: 100% !important;
    max-width: 100% !important;
    margin-right: 0 !important;
    box-sizing: border-box !important;
  }

  /* Fix nested dt/dd elements in alerts */
  .alert-details-list .custom-alert {
    display: flex !important;
    flex-direction: row !important;
    width: 100% !important;
    max-width: 100% !important;
    margin-right: 0 !important;
    box-sizing: border-box !important;
  }

  /* Remove width restriction on parent container */
  .ship-details-content {
    width: 100% !important;
    max-width: 100% !important;
    padding: 10px !important;
    box-sizing: border-box !important;
  }

  /* Force tables to take full width */
  .ship-table,
  .ship-table tr,
  .ship-table td {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* Fix any potential overflow issues */
  .ship-details-content dd {
    overflow-wrap: break-word !important;
    word-wrap: break-word !important;
  }
}

.alert-container dt,
.custom-alert dt {
  font-weight: normal !important;
  color: #000000 !important;
}

.map-wrapper {
  position: relative;
  width: 100%;
}

</style>
